/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** AddOpenItemReqDTO */
export interface AddOpenItemReqDTO {
  /** app key */
  appKey: string;
  /**
   * customer shop id
   * @format int64
   */
  customerShopId: number;
  /** item code */
  itemCode: string;
  /** item name */
  itemName: string;
  /** item main image */
  mainImage?: string;
  /** item sale price */
  salePrice?: number;
  /** sign */
  sign: string;
  /** sku list */
  skuList?: OpenItemSkuDTO[];
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** AdditionCheckTypePojo */
export interface AdditionCheckTypePojo {
  /** @format int32 */
  additionCheckType?: number;
  warehouseCode?: string;
  warehouseCountry?: string;
}

/** AdditionUpdatePojo */
export interface AdditionUpdatePojo {
  /** @format int64 */
  newAdditionConfigId?: number;
  /** @format int64 */
  oldAdditionConfigId?: number;
}

/** AdditionsPojo */
export interface AdditionsPojo {
  additionalList?: ThirdShopItemAddition[];
  warehouseCode?: string;
  warehouseCountry?: string;
}

/** Address */
export interface Address {
  /** The street address information. */
  addressLine1: string;
  /** Additional street address information, if required. */
  addressLine2?: string;
  /** The city. */
  city: string;
  /** The country code in two-character ISO 3166-1 alpha-2 format. */
  countryCode: string;
  /** The district or county. */
  districtOrCounty?: string;
  /** Name of the individual or business. */
  name: string;
  /** The postal code.  If postal codes are used in your marketplace, we recommended that you include one with your request. This helps Amazon select the most appropriate Amazon fulfillment center for the inbound shipment plan. */
  postalCode: string;
  /** The state or province code.  If state or province codes are used in your marketplace, it is recommended that you include one with your request. This helps Amazon to select the most appropriate Amazon fulfillment center for your inbound shipment plan. */
  stateOrProvinceCode: string;
}

/** AmazonError */
export interface AmazonError {
  code?: string;
  details?: string;
  message?: string;
}

/** AmazonProduct */
export interface AmazonProduct {
  amazonAsin?: string;
  amazonFnsku?: string;
  amazonMsku?: string;
  /** @format int32 */
  amazonNotSellQuantity?: number;
  /** @format int32 */
  amazonPredictTotalQuantity?: number;
  /** @format int32 */
  amazonReservedQuantity?: number;
  /** @format int32 */
  amazonSellQuantity?: number;
  /** @format int32 */
  amazonStockInQuantity?: number;
  /** @format int32 */
  amazonSurveyQuantity?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  expiration?: string;
  /** @format int64 */
  id?: number;
  /** @format int32 */
  isValid?: number;
  labelOwnerConstraint?: string;
  mainImg?: string;
  prepCategory?: string;
  prepOwnerConstraint?: string;
  productName?: string;
  productProp?: string;
  productSku?: string;
  /** @format int32 */
  sellStatus?: number;
  /** @format date-time */
  updateTime?: string;
}

/** AmazonProductResp */
export interface AmazonProductResp {
  amazonAsin?: string;
  amazonFnsku?: string;
  amazonMsku?: string;
  /** @format int32 */
  amazonNotSellQuantity?: number;
  /** @format int32 */
  amazonPredictTotalQuantity?: number;
  /** @format int64 */
  amazonProductId?: number;
  /** @format int32 */
  amazonReservedQuantity?: number;
  /** @format int32 */
  amazonSellQuantity?: number;
  /** @format int32 */
  amazonStockInQuantity?: number;
  /** @format int32 */
  amazonSurveyQuantity?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  /** @format int32 */
  customerShopPlatform?: number;
  mainImg?: string;
  productName?: string;
  productProp?: string;
  productSku?: string;
  /** @format int32 */
  sellStatus?: number;
  /** @format date-time */
  updateTime?: string;
}

/** AmazonResponseBody */
export interface AmazonResponseBody {
  errors?: AmazonError[];
}

/**
 * Amount
 * The monetary value.
 */
export interface Amount {
  currencyCode: "USD" | "GBP";
  /** The amount. */
  value: number;
}

/** ApiDeliverItem */
export interface ApiDeliverItem {
  /** @format int32 */
  qty?: number;
  thirdShopSku?: string;
}

/** ApiShopInfoResp */
export interface ApiShopInfoResp {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  noBindShopProductSkuCount?: number;
  /** @format int32 */
  notFinishedOrderCount?: number;
  /** @format int32 */
  orderStatusFailCount?: number;
}

/** BatchUpdateSyncLogisticsNoReq */
export interface BatchUpdateSyncLogisticsNoReq {
  shopOrderIds?: number[];
  /** @format int32 */
  status?: number;
}

/** BindedShopSkuInfo */
export interface BindedShopSkuInfo {
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSkuCode?: string;
}

/** BizResponse */
export interface BizResponse {
  code?: string;
  data?: object;
  msg?: string;
  success?: boolean;
}

/**
 * BoxContentsFeeDetails
 * The manual processing fee per unit and total fee for a shipment.
 */
export interface BoxContentsFeeDetails {
  /** The manual processing fee per unit. */
  feePerUnit?: Amount;
  /** The total manual processing fee for the shipment. */
  totalFee?: Amount;
  /**
   * The number of units to ship.
   * @format int32
   */
  totalUnits?: number;
}

/**
 * BoxInput
 * Input information for a given box.
 */
export interface BoxInput {
  /** The dimension values and unit of measurement. */
  dimensions?: Dimensions;
  items?: ItemInput[];
  /** @format int32 */
  quantity?: number;
  /** The weight of the package. */
  weight?: Weight;
}

/** Cafe24AuthRequest */
export interface Cafe24AuthRequest {
  code?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  thirdShopId?: string;
}

/** CartonItemVO */
export interface CartonItemVO {
  quantityInCase?: string;
  quantityShipped?: string;
  sku?: string;
}

/** CartonVO */
export interface CartonVO {
  cartonItemList?: CartonItemVO[];
}

/** CombinationPlatformProduct */
export interface CombinationPlatformProduct {
  combinationProduct?: CombinationProduct;
  commonPlatformProducts?: CommonPlatformProductDTO[];
  oemPlatformProducts?: OemPlatformProductDTO[];
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
}

/** CombinationProduct */
export interface CombinationProduct {
  combinationProductMainImg?: string;
  combinationProductName?: string;
  combinationProductProp?: string;
  combinationProductSku?: string;
  country?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  /** @format int32 */
  existWaitCombinationFlag?: number;
  productSellPrice?: number;
  /** @format int32 */
  systemSource?: number;
  unitPrice?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CombinationSubProduct */
export interface CombinationSubProduct {
  /** @format int32 */
  additionCheckType?: number;
  additionList?: ThirdShopItemAddition[];
  /** @format int64 */
  combinationProductItemId?: number;
  combinationProductSku?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  /** @format int32 */
  freezeQuantity?: number;
  goodsCountry?: string;
  /** @format int32 */
  minOrderQuantity?: number;
  /** @format int32 */
  onTheWayCancelQuantity?: number;
  /** @format int32 */
  onTheWayFreezeQuantity?: number;
  /** @format int64 */
  productCategoryFrontendNdId?: number;
  productCode?: string;
  productPropertiesName?: string;
  productSellPrice?: number;
  productSku?: string;
  productSkuImg?: string;
  productTitle?: string;
  productTitleJp?: string;
  /** @format int32 */
  productType?: number;
  purchaseCountry?: string;
  shopProductSku?: string;
  /** @format int32 */
  unitNums?: number;
  /** @format int32 */
  waitReplenishQuantity?: number;
}

/** CommonPlatformProduct */
export interface CommonPlatformProduct {
  /** @format int32 */
  atlasFlag?: number;
  bought?: boolean;
  brandFlag?: boolean;
  /** @format int32 */
  channel?: number;
  choiceFlag?: boolean;
  country?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int32 */
  fixedPriceFlag?: number;
  gradientPrices?: GradientPrice[];
  isInBlank?: boolean;
  isInProductCategoryClose?: boolean;
  isOnline?: boolean;
  isOnlineProduct?: boolean;
  materialInfoJa?: string;
  materialInfoZh?: string;
  productCategoryFrontendNdId?: string;
  productCode?: string;
  productCustoms?: ProductCustoms;
  /** @format int64 */
  productCustomsId?: number;
  productDetailUrl?: string;
  productImage?: string;
  productItemCategoryZh?: string;
  productOriginSellPrice?: number;
  productProperties?: string;
  productPropertiesName?: string;
  productPropertiesNameParse?: string;
  productSellPrice?: number;
  /** @format int32 */
  productSellQuantity?: number;
  productSku?: string;
  productSkuImg?: string;
  /** @format int32 */
  productStockQuantity?: number;
  productTitle?: string;
  productTitleJp?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  purchaseCountry?: string;
  recommendProductSku?: string;
  skuId?: string;
  skuPrice?: number;
  specId?: string;
  stallProductSellPrice?: number;
  /** @format int32 */
  switchAllIncludePriceJp?: number;
}

/** CommonPlatformProductDTO */
export interface CommonPlatformProductDTO {
  commonPlatformProduct?: CommonPlatformProduct;
  /** @format int32 */
  num?: number;
}

/** CommonTransportResult */
export interface CommonTransportResult {
  /** The workflow status for a shipment with an Amazon-partnered carrier. */
  transportResult?: TransportResult;
}

/**
 * Contact
 * Contact information for the person in the seller's organization who is responsible for a Less Than Truckload/Full Truckload (LTL/FTL) shipment.
 */
export interface Contact {
  /** The email address of the contact person. */
  email: string;
  /** The fax number of the contact person. */
  fax?: string;
  /** The name of the contact person. */
  name: string;
  /** The phone number of the contact person. */
  phone: string;
}

/** CreateCrossMallDeliveryOrderRequest */
export interface CreateCrossMallDeliveryOrderRequest {
  idList?: number[];
}

/** CreateErrorModel */
export interface CreateErrorModel {
  detailError?: string;
  /** @format int32 */
  errorType?: number;
  msku?: string;
}

/** CreateInboundShipmentPlanReq */
export interface CreateInboundShipmentPlanReq {
  /** The request schema for the createInboundShipmentPlan operation. */
  createInboundShipmentPlanRequest?: CreateInboundShipmentPlanRequest;
  /** @format int64 */
  customerShopId?: number;
}

/**
 * CreateInboundShipmentPlanRequest
 * The request schema for the createInboundShipmentPlan operation.
 */
export interface CreateInboundShipmentPlanRequest {
  inboundShipmentPlanRequestItems: InboundShipmentPlanRequestItem[];
  /** The seller's preference for label preparation for an inbound shipment. */
  labelPrepPreference: "SELLER_LABEL" | "AMAZON_LABEL_ONLY" | "AMAZON_LABEL_PREFERRED";
  /** The address from which the inbound shipment will be sent. */
  shipFromAddress: Address;
  /** The two-character country code for the country where the inbound shipment is to be sent.  Note: Not required. Specifying both ShipToCountryCode and ShipToCountrySubdivisionCode returns an error.   Values:   ShipToCountryCode values for North America:  * CA – Canada  * MX - Mexico  * US - United States  ShipToCountryCode values for MCI sellers in Europe:  * DE – Germany  * ES – Spain  * FR – France  * GB – United Kingdom  * IT – Italy  Default: The country code for the seller's home marketplace. */
  shipToCountryCode?: string;
  /** The two-character country code, followed by a dash and then up to three characters that represent the subdivision of the country where the inbound shipment is to be sent. For example, "IN-MH". In full ISO 3166-2 format.  Note: Not required. Specifying both ShipToCountryCode and ShipToCountrySubdivisionCode returns an error. */
  shipToCountrySubdivisionCode?: string;
}

/** CreateInboundShipmentPlanResp */
export interface CreateInboundShipmentPlanResp {
  amazonResponseBody?: AmazonResponseBody;
  /** 错误列表 */
  errorList?: ErrorSku[];
  inboundShipmentPlans?: InboundShipmentPlan[];
  /** 新错误列表 */
  newErrorList?: CreateErrorModel[];
  success?: boolean;
  taskId?: string;
}

/** CreateInboundShipmentReq */
export interface CreateInboundShipmentReq {
  /** @format int64 */
  customerShopId?: number;
  /** The request schema for an inbound shipment. */
  inboundShipmentRequest?: InboundShipmentRequest;
  shipmentId?: string;
}

/** CreateInboundShipmentResp */
export interface CreateInboundShipmentResp {
  amazonResponseBody?: AmazonResponseBody;
  /** A list of error responses returned when a request is unsuccessful. */
  errorList?: ErrorList;
  shipmentId?: string;
  success?: boolean;
}

/** CreateOrderReqDTO */
export interface CreateOrderReqDTO {
  /** app key */
  appKey: string;
  /**
   * currency (JPY,CNY,USD.......)
   * @example "JPY"
   */
  currency: string;
  /**
   * customer shop id
   * @format int64
   */
  customerShopId: number;
  /** order items */
  items?: OrderItem[];
  /** order total amount */
  orderAmount: number;
  /** order number, if null, it will be automatically generated */
  orderNo?: string;
  /**
   * ordered time default current time
   * @format date-time
   */
  orderTime?: string;
  /** receiver info */
  receiver?: Receiver;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** CreateReplenishPlanAddressReq */
export interface CreateReplenishPlanAddressReq {
  address?: string;
  area?: string;
  city?: string;
  clubCode?: string;
  companyName?: string;
  email?: string;
  mobile?: string;
  name?: string;
  nation?: string;
  postalCode?: string;
  province?: string;
}

/** CreateReplenishPlanItemReq */
export interface CreateReplenishPlanItemReq {
  /** @format int32 */
  deliveryNums?: number;
  shopProductSku?: string;
}

/** CreateReplenishPlanReq */
export interface CreateReplenishPlanReq {
  additionalList?: SubmitAdditionReq[];
  /** @format int32 */
  allIncludeFlag?: number;
  branchCode?: string;
  declarationAddress?: CreateReplenishPlanAddressReq;
  declarationDiscount?: number;
  distribution?: string;
  financialInstitutionCode?: string;
  forwarder?: string;
  importerCode?: string;
  /** @format int64 */
  intForwarderConfigId?: number;
  /** @format int64 */
  intShipConfigId?: number;
  /** @format int64 */
  labelTemplateId?: number;
  originalDeclarationAddress?: CreateReplenishPlanAddressReq;
  /** @format int32 */
  priceDeclarationType?: number;
  replenishPlanItemList?: CreateReplenishPlanItemReq[];
  shippingType?: string;
  /** @format int32 */
  tariffType?: number;
  taxDeductionAccount?: string;
  title?: string;
  /** @format int32 */
  transportType?: number;
  warehouseCode?: string;
}

/** CreateShopOrderRequest */
export interface CreateShopOrderRequest {
  /** @format int64 */
  customerShopId?: number;
  shopOrderIds?: number[];
  useOneTheWayInventory?: boolean;
}

/** CreateXmlVO */
export interface CreateXmlVO {
  boxInputList?: BoxInput[];
  cartonList?: CartonVO[];
  messageId?: string;
  /** @format int32 */
  numCartons?: number;
  sellerId?: string;
  shipmentId?: string;
  xmlPath?: string;
}

/** CrossMallOrderAddressEditRequest */
export interface CrossMallOrderAddressEditRequest {
  /** 订单id */
  orderIdList?: number[];
  /** 收件人地址 */
  shipAddress?: string;
  /** 收件人城市 */
  shipCity?: string;
  /** 收件人国家code */
  shipCountryCode?: string;
  /** 收件人国家名称 */
  shipCountryName?: string;
  /** 收件人邮箱 */
  shipMail?: string;
  /** 收件人名称 */
  shipName?: string;
  /** 收件人省份 */
  shipProvince?: string;
  /** 收件人电话 */
  shipTel?: string;
  /** 收件人邮编 */
  shipZip?: string;
}

/** CrossMallOrderDeleteRequest */
export interface CrossMallOrderDeleteRequest {
  /** 订单id列表 */
  orderIdList?: number[];
}

/** CrossMallOrderInterceptRequest */
export interface CrossMallOrderInterceptRequest {
  /**
   * 拦截标志 1-开启拦截 2-取消拦截
   * @format int32
   */
  interceptFlag?: number;
  /**
   * 订单id
   * @format int64
   */
  orderId?: number;
}

/** CrossMallOrderItem */
export interface CrossMallOrderItem {
  /** @format int32 */
  amount?: number;
  amountPrice?: number;
  attribute1Code?: string;
  attribute1Name?: string;
  attribute2Code?: string;
  attribute2Name?: string;
  /** @format int32 */
  componentFlag?: number;
  /** @format date-time */
  createTime?: string;
  customerProduct?: CustomerProductDataEntity;
  /** @format int64 */
  customerShopId?: number;
  freeItemCode?: string;
  /** @format int32 */
  freightType?: number;
  /** @format int64 */
  id?: number;
  /** @format int32 */
  isDelete?: number;
  itemCode?: string;
  itemName?: string;
  janCd?: string;
  leadTimeText?: string;
  lineNo?: string;
  orderCode?: string;
  /** @format int64 */
  orderId?: number;
  orderNumber?: string;
  productSnapshot?: string;
  /** @format int32 */
  reducedTaxRateType?: number;
  /** @format int32 */
  senderType?: number;
  skuCode?: string;
  /** @format int32 */
  targetStockType?: number;
  taxRate?: number;
  /** @format int32 */
  taxType?: number;
  unitPrice?: number;
  /** @format date-time */
  updateTime?: string;
  warehouse?: string;
}

/** CrossMallOrderQueryRequest */
export interface CrossMallOrderQueryRequest {
  /** 客户名称 */
  clientName?: string;
  /**
   * 创建时间开始
   * @format date-time
   */
  createdAtBegin?: string;
  /**
   * 创建时间结束
   * @format date-time
   */
  createdAtEnd?: string;
  /**
   * 客户店铺id
   * @format int64
   */
  customerShopId?: number;
  /**
   * 配送希望日开始
   * @format date-time
   */
  deliveryReqDateBegin?: string;
  /**
   * 配送希望日结束
   * @format date-time
   */
  deliveryReqDateEnd?: string;
  /** 物流名称 */
  distribution?: string;
  /**
   * 是否拦截 0-否 1:是
   * @format int32
   */
  interceptStatus?: number;
  /** 商品SPU编码 */
  itemCode?: string;
  /**
   * 商品物流id
   * @format int64
   */
  itemShipConfigId?: number;
  /** 订单编号 */
  orderCode?: string;
  /** 管理番号列表 */
  orderNumberList?: string[];
  /**
   * 订单物流id
   * @format int64
   */
  orderShipConfigId?: number;
  /**
   * 订单同步状态 0-未下单 1-已下单
   * @format int32
   */
  orderSyncStatus?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 订单状态 */
  phaseName?: string;
  /**
   * 同捆数量
   * @format int32
   */
  samePackageNum?: number;
  /**
   * 同捆数量操作符 1:>= 2:= 3:<=
   * @format int32
   */
  samePackageOperation?: number;
  /** 收货国家 */
  shipCountry?: string;
  /** 收货地区 */
  shipProvince?: string;
  /** 店铺名称 */
  shopName?: string;
  /**
   * 单多品标记 0:多品 1:单品
   * @format int32
   */
  singleProduct?: number;
  /** 商品SKU编码 */
  skuCode?: string;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
}

/** CrossMallOrderResp */
export interface CrossMallOrderResp {
  /** 送料-运费 */
  carriagePrice?: number;
  /** 代引料 */
  cashOnDelivery?: number;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /**
   * 作成日時
   * @format date-time
   */
  createdAt?: string;
  /**
   * 客户id
   * @format int64
   */
  customerId?: number;
  /**
   * 客户店铺id
   * @format int64
   */
  customerShopId?: number;
  /** 配送便编码 */
  deliveryCode?: string;
  /**
   * 発送日
   * @format date-time
   */
  deliveryDate?: string;
  /** 配送便名 */
  deliveryName?: string;
  /**
   * 待发货数量
   * @format int32
   */
  deliveryNums?: number;
  /**
   * 配送希望日
   * @format date-time
   */
  deliveryReqDate?: string;
  /** 物流名称 */
  distribution?: string;
  /** 错误码 */
  errorCode?: string;
  /** 错误消息 */
  errorMsg?: string;
  /**
   * 主键ID
   * @format int64
   */
  id?: number;
  /**
   * 物流配置id
   * @format int64
   */
  intShipConfigId?: number;
  /**
   * 拦截状态 0-初始 1:开启拦截 2:取消拦截
   * @format int32
   */
  interceptStatus?: number;
  /**
   * 拦截时间
   * @format date-time
   */
  interceptTime?: string;
  /** 订单商品列表 */
  itemList?: CrossMallOrderItem[];
  /** 订单编号 */
  orderCode?: string;
  /**
   * 下单时间
   * @format date-time
   */
  orderDate?: string;
  /** 订单备注 */
  orderMemo?: string;
  /** 管理番号 */
  orderNumber?: string;
  /**
   * 订单同步状态 0.未下单 1、已下单  2.下单中 3.下单失败
   * @format int32
   */
  orderSyncStatus?: number;
  /** 注文処理フェーズ */
  phaseName?: string;
  /** 注文者住所1 */
  shipAddress1?: string;
  /** 注文者住所2 */
  shipAddress2?: string;
  /**
   * 地址已编辑标记
   * @format int32
   */
  shipAddressEditFlag?: number;
  /** 城市 */
  shipCity?: string;
  /** 国家代码 */
  shipCountry?: string;
  /**
   * 物流已编辑标记
   * @format int32
   */
  shipEditFlag?: number;
  /** 注文者カナ-假名 */
  shipKana?: string;
  /** 收件人邮箱 */
  shipMail?: string;
  /** 注文者氏名 */
  shipName?: string;
  /** 省/州 */
  shipProvince?: string;
  /** 届け先会社名-收件人 */
  shipSectionName1?: string;
  /** 注文者部署名--收件人 */
  shipSectionName2?: string;
  /** 注文者TEL */
  shipTel?: string;
  /** 注文者郵便番号 */
  shipZip?: string;
  /** 店铺code */
  shopCode?: string;
  /** 店铺名称 */
  shopName?: string;
  /**
   * 单多品标记 0:多品 1:单品
   * @format int32
   */
  singleProduct?: number;
  /** 小計 */
  subtotalPrice?: number;
  /** 合計 */
  totalPrice?: number;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
  /**
   * 更新日時
   * @format date-time
   */
  updatedAt?: string;
  /** 仓库编号 */
  warehouse?: string;
}

/** CrossMallOrderShipEditRequest */
export interface CrossMallOrderShipEditRequest {
  /**
   * 物流配置id
   * @format int64
   */
  intShipConfigId?: number;
  /** 订单id */
  orderIdList?: number[];
}

/** CrossMallProduct */
export interface CrossMallProduct {
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  id?: number;
  productCode?: string;
  productImage?: string;
  productName?: string;
  productProp?: string;
  productSku?: string;
  prop1?: string;
  prop2?: string;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CrossMallProductResp */
export interface CrossMallProductResp {
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  productCode?: string;
  productImage?: string;
  productName?: string;
  productProp?: string;
  productSku?: string;
  prop1?: string;
  prop2?: string;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerProductDataEntity */
export interface CustomerProductDataEntity {
  ckbProductSku?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  creatorId?: number;
  creatorName?: string;
  customerProductCode?: string;
  customerProductSku?: string;
  distribution?: string;
  /** @format int64 */
  editorId?: number;
  editorName?: string;
  /** @format int32 */
  height?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  intShipConfigId?: number;
  /** @format int32 */
  length?: number;
  /** @format int32 */
  maxPackageNum?: number;
  productCategoryName?: string;
  productImg?: string;
  productLink?: string;
  productName?: string;
  productProp?: string;
  productPropOne?: string;
  productPropTwo?: string;
  /** @format int32 */
  relateStatus?: number;
  /** @format int32 */
  thickness?: number;
  /** @format int32 */
  threeSideSum?: number;
  /** @format date-time */
  updateTime?: string;
  warehouse?: string;
  /** @format int32 */
  weight?: number;
  /** @format int32 */
  width?: number;
}

/** CustomerProductDataPageDTO */
export interface CustomerProductDataPageDTO {
  /** CKB平台SKU */
  ckbProductSku?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** @format int64 */
  creatorId?: number;
  creatorName?: string;
  /** SPU */
  customerProductCode?: string;
  /** SKU */
  customerProductSku?: string;
  /** 配送公司 */
  distribution?: string;
  /** @format int64 */
  editorId?: number;
  editorName?: string;
  /**
   * 高
   * @format int32
   */
  height?: number;
  /**
   * 主键id
   * @format int64
   */
  id?: number;
  /**
   * 配送公司id
   * @format int64
   */
  intShipConfigId?: number;
  /**
   * 长
   * @format int32
   */
  length?: number;
  /**
   * 最大同包裹数
   * @format int32
   */
  maxPackageNum?: number;
  /** 品名 */
  productCategoryName?: string;
  /** 商品图片 */
  productImg?: string;
  /** CKB商品链接 */
  productLink?: string;
  /** 商品名称 */
  productName?: string;
  /** 商品属性 */
  productProp?: string;
  productPropOne?: string;
  productPropTwo?: string;
  /**
   * 关联状态
   * @format int32
   */
  relateStatus?: number;
  /**
   * 厚度cm
   * @format int32
   */
  thickness?: number;
  /**
   * 三边和cm
   * @format int32
   */
  threeSideSum?: number;
  /**
   * 修改时间
   * @format date-time
   */
  updateTime?: string;
  /** 仓库 */
  warehouse?: string;
  /**
   * 重量g
   * @format int32
   */
  weight?: number;
  /**
   * 宽
   * @format int32
   */
  width?: number;
}

/** CustomerProductDataPageRequest */
export interface CustomerProductDataPageRequest {
  /** CKB平台SKU */
  ckbProductSku?: string;
  /**
   * 创建时间-结束
   * @format date-time
   */
  createTimeEnd?: string;
  /**
   * 创建时间-开始
   * @format date-time
   */
  createTimeStart?: string;
  /** SPU */
  customerProductCode?: string;
  /** SKU */
  customerProductSku?: string;
  /** SKUs */
  customerProductSkuList?: string[];
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 商品名称 */
  productName?: string;
  /**
   * 关联状态
   * @format int32
   */
  relateStatus?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
}

/** CustomerReplenishPlanReq */
export interface CustomerReplenishPlanReq {
  amazonMsku?: string;
  amazonMskuList?: string[];
  /** @format int64 */
  customerShopId?: number;
  deliveryTaskCode?: string;
  deliveryTaskCodeList?: string[];
  keywordName?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  planStatus?: number;
  productSku?: string;
  productSkuList?: string[];
  shipmentId?: string;
  shipmentIdList?: string[];
}

/** CustomerShopAuthResp */
export interface CustomerShopAuthResp {
  accessToken?: string;
  /** @format int64 */
  authExpireTime?: number;
  /** @format int64 */
  customerShopAuthId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  customerShopPlatform?: number;
  refreshToken?: string;
  /** @format date-time */
  refreshTokenExpireDate?: string;
  shopId?: string;
  shopName?: string;
  shopUrl?: string;
}

/** DelAppWebhookDTO */
export interface DelAppWebhookDTO {
  /** @format int32 */
  event_no?: number;
  resource?: ResourceDTO;
}

/** DeleteShopOrderItemRequest */
export interface DeleteShopOrderItemRequest {
  shopOrderItemIds?: number[];
}

/** DeleteShopOrderRequest */
export interface DeleteShopOrderRequest {
  shopOrderIds?: number[];
}

/** DeliveryAdditionsPojo */
export interface DeliveryAdditionsPojo {
  deliveryAdditionalList?: ThirdShopOrderDeliveryAddition[];
  warehouseCode?: string;
  warehouseCountry?: string;
  warehouseName?: string;
}

/** DeliverySkuFeeDetailReqDTO */
export interface DeliverySkuFeeDetailReqDTO {
  /** app key */
  appKey: string;
  /**
   * paging Amount per Page
   * @format int64
   */
  customerShopId: number;
  deliveryOrderNo?: string;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageNo: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageSize: number;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** DeliverySkuFeeDetailRespDTO */
export interface DeliverySkuFeeDetailRespDTO {
  /** @format int32 */
  code?: number;
  data?: TotalCostData[];
  message?: string;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  sizePerPage?: number;
  /** @format int32 */
  total?: number;
}

/** DetailCostData */
export interface DetailCostData {
  antiScratchBoardPaperFee?: number;
  boxFoldingAndProductPackingFee?: number;
  bubbleWrapFee?: number;
  buttonholeMakingFee?: number;
  cartonLabelingFee?: number;
  ckbGeneralCartonFee?: number;
  clothLabelCuttingFee?: number;
  clothLabelSewingFee?: number;
  combinationReworkFee?: number;
  compressionBagPackingFee?: number;
  couponInspectionFee?: number;
  couponShippingFee?: number;
  customizedCartonFee?: number;
  customizedOppBagFee?: number;
  defectiveRePurchaseFee?: number;
  defectiveReturnFee?: number;
  deliveryOrderNo?: string;
  /** @format int64 */
  deliveryQuantity?: number;
  /** @format date-time */
  deliveryTime?: string;
  detailedSurfaceAndInsideInspectionFee?: number;
  domesticShippingFee?: number;
  factoryOriginalBoxFee?: number;
  fragileStickerFee?: number;
  giftActivityFee?: number;
  goodsBubbleWrapServiceFee?: number;
  goodsCushionServiceFee?: number;
  goodsWrappingFilmServiceFee?: number;
  guaranteeCardInspectionFee?: number;
  guaranteeCardShippingFee?: number;
  hangingTagCuttingFee?: number;
  hangingTagFee?: number;
  hangingTagInsertionFee?: number;
  instructionManualFee?: number;
  internationalShippingFee?: number;
  inventoryStorageFee?: number;
  ironingFee?: number;
  jewelryMountingFee?: number;
  labelingFee?: number;
  leatherLabelSewingFee?: number;
  looseInspectionFee?: number;
  looseQualityInspectionAndDefectRepairFee?: number;
  madeInChinaStickerFee?: number;
  marketProductPurchaseFee?: number;
  nashiPaperPackagingInspectionFee?: number;
  nashiPaperPackagingShippingFee?: number;
  needleInspectionServiceFee?: number;
  newProductServiceFee?: number;
  odorRemovalFee?: number;
  oemBulkPurchaseFee?: number;
  oemSamplePurchaseFee?: number;
  oemSourcingFee?: number;
  offTheShelfPurchaseFee?: number;
  oppBagReplacementForChineseBoxFee?: number;
  oppBagReplacementForOriginalBoxFee?: number;
  ordinaryOppBagFee?: number;
  originalLabelCuttingFee?: number;
  originalLabelRemovalFee?: number;
  otherMaterialsPlacementInspectionFee?: number;
  otherMaterialsPlacementShippingFee?: number;
  outboundFee?: number;
  outboundWithInternationalShippingFee?: number;
  packageRetentionFee?: number;
  packingServiceFee?: number;
  palletizingFee?: number;
  powerOnInspectionFee?: number;
  productAmount?: number;
  productCombinationFee?: number;
  productName?: string;
  productSku?: string;
  ribbonPackagingInspectionFee?: number;
  ribbonPackagingShippingFee?: number;
  scratchCardInspectionFee?: number;
  scratchCardShippingFee?: number;
  shippingBagCustomizedFee?: number;
  shippingBagOrdinaryFee?: number;
  shippingCushionFee?: number;
  shippingInnerBoxFee?: number;
  shopProductSku?: string;
  simpleInspectionAndDefectRepairFee?: number;
  simpleSurfaceInspectionFee?: number;
  sizeChangeFee?: number;
  sizeMeasurementServiceFee?: number;
  specialStorageBagFee?: number;
  stickerApplyingFee?: number;
  styleConfirmationServiceFee?: number;
  taxFee?: number;
  thankYouCardInspectionFee?: number;
  thankYouCardShippingFee?: number;
  warehousingFee?: number;
  washingLabelCuttingFee?: number;
  washingLabelSewingFee?: number;
  washingTagProductionFee?: number;
  woodenFrameForGoodsFee?: number;
  wrappingFilmForOuterBoxFee?: number;
  xrayNeedleInspectionFee?: number;
}

/**
 * Dimensions
 * The dimension values and unit of measurement.
 */
export interface Dimensions {
  /** The height dimension. */
  height: number;
  /** The length dimension. */
  length: number;
  /** The unit of measurement for the dimensions. */
  unit: "inches" | "centimeters";
  unitOfMeasurement: "IN" | "CM";
  /** The width dimension. */
  width: number;
}

/** EditDeliveryAdditionsRequest */
export interface EditDeliveryAdditionsRequest {
  deliveryAdditions?: ThirdShopOrderDeliveryAddition[];
  shopOrderIds?: string[];
  warehouseCode?: string;
}

/** EditIntShipConfigRequest */
export interface EditIntShipConfigRequest {
  intShipConfigList?: IntShipConfigPojo[];
  shopOrderIds?: number[];
}

/**
 * Error
 * An error response returned when the request is unsuccessful.
 */
export interface Error {
  /** An error code that identifies the type of error that occurred. */
  code: string;
  /** Additional details that can help the caller understand or fix the issue. */
  details?: string;
  /** A message that describes the error condition in a human-readable form. */
  message: string;
}

/**
 * ErrorList
 * A list of error responses returned when a request is unsuccessful.
 */
export interface ErrorList {
  errors: Error[];
}

/** ErrorSku */
export interface ErrorSku {
  /** 失败 sku 列表 */
  amazonSku?: string[];
  /** 失败原因 */
  reason?: string;
}

/** FbaShipmentBoxesItemDTO */
export interface FbaShipmentBoxesItemDTO {
  asin?: string;
  expiration?: string;
  fnsku?: string;
  labelOwner?: string;
  manufacturingLotCode?: string;
  msku?: string;
  /** @format int32 */
  quantity?: number;
}

/** FbaShipmentBoxesRespDTO */
export interface FbaShipmentBoxesRespDTO {
  boxId?: string;
  height?: number;
  itemDTOList?: FbaShipmentBoxesItemDTO[];
  length?: number;
  packageId?: string;
  templateName?: string;
  weight?: number;
  width?: number;
}

/**
 * FundUtilizationDetailsData
 * 资金使用明细数据
 */
export interface FundUtilizationDetailsData {
  /** 剩余可用金额 */
  availableAmount?: number;
  /** 手续费 */
  handlingFee?: number;
  /** 手续费明细 */
  handlingFeeDetail?: HandlingFeeDetail;
  /** @format int32 */
  pageIndex?: number;
  /** 入金总额：充值+转入-提现-转出 */
  paymentAmount?: number;
  /** 商品金额(代金或结算金额) */
  productAmount?: number;
  /** 商品金额明细列表 */
  productAmountDetailList?: ProductAmountDetail[];
  /** @format int32 */
  sizePerPage?: number;
  /** @format int32 */
  total?: number;
}

/**
 * FundUtilizationDetailsRequestDTO
 * 获取店铺资金使用明细请求参数
 */
export interface FundUtilizationDetailsRequestDTO {
  /** app key */
  appKey: string;
  /**
   * 店铺ID
   * @format int64
   */
  customerShopId: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageNo: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageSize: number;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** GetAmazonProductByMskuRequest */
export interface GetAmazonProductByMskuRequest {
  amazonMsku?: string;
  amazonSkuList?: string[];
  /** @format int64 */
  customerShopId?: number;
}

/** GetCrossMallProductRequest */
export interface GetCrossMallProductRequest {
  crossMallProductSku?: string;
  /** @format int64 */
  customerShopId?: number;
}

/** GetLabelReq */
export interface GetLabelReq {
  /** @format int64 */
  customerShopId?: number;
  labelType?: string;
  /** @format int32 */
  numberOfPackages?: number;
  /** @format int32 */
  numberOfPallets?: number;
  packageLabelsToPrint?: string[];
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  pageStartIndex?: number;
  pageType?: string;
  shipmentId?: string;
}

/** GetLabelResp */
export interface GetLabelResp {
  downloadUrl?: string;
}

/** GetOrderReqDTO */
export interface GetOrderReqDTO {
  /** app key */
  appKey: string;
  /**
   * customer shop id
   * @format int64
   */
  customerShopId: number;
  /** order number separated by commas */
  orderNos: string;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** GetUploadStatusReq */
export interface GetUploadStatusReq {
  /** @format int64 */
  customerShopId?: number;
  feedId?: string;
}

/** GetUploadStatusResp */
export interface GetUploadStatusResp {
  feedId?: string;
  feedType?: string;
  processingStatus?: "CANCELLED" | "DONE" | "FATAL" | "IN_PROGRESS" | "IN_QUEUE";
  resultFeedDocumentId?: string;
}

/** GradientPrice */
export interface GradientPrice {
  /** @format int32 */
  minQuantity?: number;
  price?: number;
}

/**
 * HandlingFeeDetail
 * 手续费明细
 */
export interface HandlingFeeDetail {
  /** 国内运费 */
  domesticShippingFee?: number;
  /** 默认手续费 */
  handlingFee?: number;
  /** 国际运费 */
  internationalShippingFee?: number;
  /** 其他费用 */
  otherFee?: number;
  /** 商品附加费 */
  productAdditionalFee?: number;
  /** 发货附加费 */
  shippingAdditionalFee?: number;
}

/** ISortFieldEnum */
export interface ISortFieldEnum {
  asc?: boolean;
  field?: string;
}

/**
 * InboundShipmentHeader
 * Inbound shipment information used to create and update inbound shipments.
 */
export interface InboundShipmentHeader {
  /** Indicates whether or not an inbound shipment contains case-packed boxes. Note: A shipment must contain either all case-packed boxes or all individually packed boxes.  Possible values:  true - All boxes in the shipment must be case packed.  false - All boxes in the shipment must be individually packed.  Note: If AreCasesRequired = true for an inbound shipment, then the value of QuantityInCase must be greater than zero for every item in the shipment. Otherwise the service returns an error. */
  areCasesRequired?: boolean;
  /** The identifier for the fulfillment center to which the shipment will be shipped. Get this value from the InboundShipmentPlan object in the response returned by the createInboundShipmentPlan operation. */
  destinationFulfillmentCenterId: string;
  intendedBoxContentsSource?: "NONE" | "FEED" | "2D_BARCODE";
  /** The preference for label preparation for an inbound shipment. */
  labelPrepPreference: "SELLER_LABEL" | "AMAZON_LABEL_ONLY" | "AMAZON_LABEL_PREFERRED";
  /** The return address. */
  shipFromAddress: Address;
  /** The name for the shipment. Use a naming convention that helps distinguish between shipments over time, such as the date the shipment was created. */
  shipmentName: string;
  shipmentStatus:
    | "WORKING"
    | "SHIPPED"
    | "RECEIVING"
    | "CANCELLED"
    | "DELETED"
    | "CLOSED"
    | "ERROR"
    | "IN_TRANSIT"
    | "DELIVERED"
    | "CHECKED_IN";
}

/**
 * InboundShipmentItem
 * Item information for an inbound shipment. Submitted with a call to the createInboundShipment or updateInboundShipment operation.
 */
export interface InboundShipmentItem {
  /** Amazon's fulfillment network SKU of the item. */
  fulfillmentNetworkSKU?: string;
  prepDetailsList?: PrepDetails[];
  /**
   * The item quantity in each case, for case-packed items. Note that QuantityInCase multiplied by the number of boxes in the inbound shipment equals QuantityShipped. Also note that all of the boxes of an inbound shipment must either be case packed or individually packed. For that reason, when you submit the createInboundShipment or the updateInboundShipment operation, the value of QuantityInCase must be provided for every item in the shipment or for none of the items in the shipment.
   * @format int32
   */
  quantityInCase?: number;
  /**
   * The item quantity that has been received at an Amazon fulfillment center.
   * @format int32
   */
  quantityReceived?: number;
  /**
   * The item quantity that you are shipping.
   * @format int32
   */
  quantityShipped: number;
  /** The date that a pre-order item will be available for sale. */
  releaseDate?: string;
  /** The seller SKU of the item. */
  sellerSKU: string;
  /** A shipment identifier originally returned by the createInboundShipmentPlan operation. */
  shipmentId?: string;
}

/**
 * InboundShipmentPlan
 * Inbound shipment information used to create an inbound shipment. Returned by the createInboundShipmentPlan operation.
 */
export interface InboundShipmentPlan {
  /** An Amazon fulfillment center identifier created by Amazon. */
  destinationFulfillmentCenterId: string;
  /** The manual processing fee per unit and total fee for a shipment. */
  estimatedBoxContentsFee?: BoxContentsFeeDetails;
  /** SKU and quantity information for the items in the shipment. */
  items: InboundShipmentPlanItem[];
  labelPrepType: "NO_LABEL" | "SELLER_LABEL" | "AMAZON_LABEL";
  /** The address of the Amazon fulfillment center to which to ship the items. */
  shipToAddress: Address;
  /** A shipment identifier originally returned by the createInboundShipmentPlan operation. */
  shipmentId: string;
}

/**
 * InboundShipmentPlanItem
 * Item information used to create an inbound shipment. Returned by the createInboundShipmentPlan operation.
 */
export interface InboundShipmentPlanItem {
  /** Amazon's fulfillment network SKU of the item. */
  fulfillmentNetworkSKU: string;
  prepDetailsList?: PrepDetails[];
  /**
   * The item quantity that you are shipping.
   * @format int32
   */
  quantity: number;
  /** The seller SKU of the item. */
  sellerSKU: string;
}

/**
 * InboundShipmentPlanRequestItem
 * Item information for creating an inbound shipment plan. Submitted with a call to the createInboundShipmentPlan operation.
 */
export interface InboundShipmentPlanRequestItem {
  /** The Amazon Standard Identification Number (ASIN) of the item. */
  asin: string;
  condition:
    | "NewItem"
    | "NewWithWarranty"
    | "NewOEM"
    | "NewOpenBox"
    | "UsedLikeNew"
    | "UsedVeryGood"
    | "UsedGood"
    | "UsedAcceptable"
    | "UsedPoor"
    | "UsedRefurbished"
    | "CollectibleLikeNew"
    | "CollectibleVeryGood"
    | "CollectibleGood"
    | "CollectibleAcceptable"
    | "CollectiblePoor"
    | "RefurbishedWithWarranty"
    | "Refurbished"
    | "Club";
  prepDetailsList?: PrepDetails[];
  /** @format int32 */
  quantity: number;
  /**
   * The item quantity in each case, for case-packed items. Note that QuantityInCase multiplied by the number of cases in the inbound shipment equals Quantity. Also note that all of the boxes of an inbound shipment must either be case packed or individually packed. For that reason, when you submit the createInboundShipmentPlan operation, the value of QuantityInCase must be provided for every item in the shipment or for none of the items in the shipment.
   * @format int32
   */
  quantityInCase?: number;
  /** The seller SKU of the item. */
  sellerSKU: string;
}

/**
 * InboundShipmentRequest
 * The request schema for an inbound shipment.
 */
export interface InboundShipmentRequest {
  /** Inbound shipment information used to create and update inbound shipments. */
  inboundShipmentHeader: InboundShipmentHeader;
  inboundShipmentItems: InboundShipmentItem[];
  /** A marketplace identifier. Specifies the marketplace where the product would be stored. */
  marketplaceId: string;
}

/** IntShipConfigPojo */
export interface IntShipConfigPojo {
  distribution?: string;
  /** @format int64 */
  intShipConfigId?: number;
  logisticsLogo?: string;
  warehouseCode?: string;
  warehouseCountry?: string;
}

/** ItemAdditionDTO */
export interface ItemAdditionDTO {
  /** @format int32 */
  additionConfigId?: number;
  additionExtraName?: string;
  /** @format int32 */
  additionId?: number;
  additionName?: string;
  additionNameJp?: string;
  ingredientsSku?: string;
  /** @format int32 */
  spotCheckFlag?: number;
  spotCheckRatio?: number;
  warehouseCode?: string;
}

/**
 * ItemInput
 * Defines an item's input parameters.
 */
export interface ItemInput {
  /** The manufacturing lot code. */
  manufacturingLotCode?: string;
  /** Merchant SKU. */
  msku: string;
  /**
   * The number of units of the specified msku that will be shipped.
   * @format int32
   */
  quantity: number;
}

/** ItemSkuMappingQueryReq */
export interface ItemSkuMappingQueryReq {
  /** @format int64 */
  customerShopId?: number;
  customerShopIdList?: number[];
  productSkuList?: string[];
  thirdItemName?: string;
}

/** ItemSkuMappingResp */
export interface ItemSkuMappingResp {
  /** @format int64 */
  customerShopId?: number;
  mappingList?: SkuMappingInfo[];
  productSku?: string;
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSkuAttribute?: string;
  thirdSkuCode?: string;
}

/** LastUpdateTimeResult */
export interface LastUpdateTimeResult {
  /** @format date-time */
  date?: string;
}

/** ListOnTheWayStockPageRequest */
export interface ListOnTheWayStockPageRequest {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  shopOrderIds?: number[];
  /** @format int32 */
  startIndex?: number;
}

/** ListShipmentBoxesReq */
export interface ListShipmentBoxesReq {
  /** @format int64 */
  customerShopId?: number;
  planId?: string;
  shipmentId?: string;
}

/** ManualCreateOrderResult */
export interface ManualCreateOrderResult {
  errCode?: string;
  errMsg?: string;
  platformOrderNoList?: string[];
  /** @format int64 */
  shopOrderId?: number;
}

/** ManualSyncOrderRequest */
export interface ManualSyncOrderRequest {
  /** @format date-time */
  endTime?: string;
  /** @format date-time */
  startTime?: string;
}

/** MappingInfo */
export interface MappingInfo {
  operateFlag?: boolean;
  productCode?: string;
  productSku?: string;
  /** @format int32 */
  productType?: number;
}

/**
 * NonPartneredLtlDataInput
 * Information that you provide to Amazon about a Less Than Truckload/Full Truckload (LTL/FTL) shipment by a carrier that has not partnered with Amazon.
 */
export interface NonPartneredLtlDataInput {
  /** The carrier that you are using for the inbound shipment. */
  carrierName: string;
  proNumber: string;
}

/**
 * NonPartneredSmallParcelDataInput
 * Information that you provide to Amazon about a Small Parcel shipment shipped by a carrier that has not partnered with Amazon.
 */
export interface NonPartneredSmallParcelDataInput {
  /** The carrier that you are using for the inbound shipment. */
  carrierName: string;
  packageList: NonPartneredSmallParcelPackageInput[];
}

/**
 * NonPartneredSmallParcelPackageInput
 * The tracking number of the package, provided by the carrier.
 */
export interface NonPartneredSmallParcelPackageInput {
  trackingId: string;
}

/** OemPlatformProduct */
export interface OemPlatformProduct {
  color?: string;
  colorUrl?: string;
  colorZh?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  gradientPrices?: GradientPrice[];
  materials?: string;
  materialsUrl?: string;
  materialsZh?: string;
  /** @format int64 */
  oemProductClassificationId?: number;
  productCode?: string;
  productImage?: string;
  productSku?: string;
  productSkuProperties?: string;
  productTitle?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  /** @format int32 */
  quantity?: number;
  remark?: string;
  searchSourceOrder?: SearchSourceOrder;
  /** @format int64 */
  searchSourceOrderSkuId?: number;
  size?: string;
  sizeUrl?: string;
  sizeZh?: string;
  style?: string;
  styleUrl?: string;
  styleZh?: string;
}

/** OemPlatformProductDTO */
export interface OemPlatformProductDTO {
  /** @format int32 */
  num?: number;
  oemPlatformProduct?: OemPlatformProduct;
}

/** OnTheWayStockQueryResoDTO */
export interface OnTheWayStockQueryResoDTO {
  /** @format int64 */
  onTheWayAvailableNum?: number;
  /** @format int64 */
  onTheWayOccupyNum?: number;
  /** @format int64 */
  onTheWayTotalNum?: number;
  productDetailUrl?: string;
  productMainImg?: string;
  productPropertiesName?: string;
  productSku?: string;
  productTitle?: string;
  /** @format int64 */
  skuOrderNum?: number;
}

/** OpenItemSkuDTO */
export interface OpenItemSkuDTO {
  /** sku attribute */
  skuAttribute?: string;
  /** sku code */
  skuCode: string;
  /** sku image */
  skuImage?: string;
  /** sku price */
  skuPrice: number;
}

/** OpenOrderRespDTO */
export interface OpenOrderRespDTO {
  /**
   * currency (JPY,CNY,USD.......)
   * @example "JPY"
   */
  currency?: string;
  /** order items */
  items?: OrderItem[];
  /** order total amount */
  orderAmount?: number;
  /** order number */
  orderNo?: string;
  /**
   * api order status, 0-not ordered 1-ordered success 2-pending 3-ordered failed
   * @format int32
   */
  orderSyncStatus?: number;
  /**
   * ordered time default current time
   * @format date-time
   */
  orderTime?: string;
  /** ckb platform order number */
  platformOrderNo?: string;
  /**
   * ckb platform order settle status 1-unsettlement 2-settling 3-settlement success 4-settlement failed
   * @format int32
   */
  platformOrderSettleStatus?: number;
  /** receiver info */
  receiver?: Receiver;
}

/** OperationLogResp */
export interface OperationLogResp {
  /** 操作业务编号 */
  bizNo?: string;
  /** 操作业务类型 */
  bizType?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /**
   * 主键id
   * @format int64
   */
  id?: number;
  /**
   * 是否删除 0:否 1:是
   * @format int32
   */
  isDelete?: number;
  /** 备注 */
  memo?: string;
  /** 操作内容 */
  operateContent?: string;
  /** 操作描述 */
  operateDesc?: string;
  /** 操作描述日文 */
  operateDescJp?: string;
  /** 操作类型 */
  operateType?: string;
  /** 操作人id */
  operatorId?: string;
  /** 操作人名称 */
  operatorName?: string;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
}

/** OrderDeliveryReq */
export interface OrderDeliveryReq {
  cmTrackingProviderKey?: string;
  deliveryProductSkus?: string[];
  deliveryShopProductSkuList?: ApiDeliverItem[];
  deliveryShopProductSkus?: string[];
  isLastLogistics?: boolean;
  logisticsCompanyCode?: string;
  platformOrderNo?: string;
  /** @format int64 */
  shopOrderId?: number;
  shopifyTrackingProviderKey?: string;
  tikTokTrackingProviderKey?: string;
  trackingNumber?: string;
  trackingProvider?: string;
  trackingProviderKey?: string;
  trackingUrl?: string;
}

/** OrderItem */
export interface OrderItem {
  /** item amount */
  itemAmount: number;
  /**
   * order quantity
   * @format int32
   */
  quantity: number;
  /** sku code */
  skuCode: string;
}

/** OrderSkuFeeDetail */
export interface OrderSkuFeeDetail {
  /** @format date-time */
  createTime?: string;
  customerOrderNo?: string;
  /** @format int64 */
  customerShopId?: number;
  domesticShippingFee?: number;
  handlingFee?: number;
  internationalShippingFee?: number;
  /** @format int32 */
  orderSource?: number;
  platformOrderNo?: string;
  productAdditionalFee?: number;
  productSettlementAmount?: number;
  /** @format int32 */
  productSettlementQuantity?: number;
  productSku?: string;
  productUnitPrice?: number;
  shippingAdditionalFee?: number;
  shopProductSku?: string;
}

/** OrderSkuFeeDetailReqDTO */
export interface OrderSkuFeeDetailReqDTO {
  /** app key */
  appKey: string;
  /**
   * paging Amount per Page
   * @format int64
   */
  customerShopId: number;
  /** @format int32 */
  orderSource?: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageNo: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageSize: number;
  platformOrderNo?: string;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** OrderSkuFeeDetailRespDTO */
export interface OrderSkuFeeDetailRespDTO {
  /** @format int32 */
  code?: number;
  data?: OrderSkuFeeDetail[];
  message?: string;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  sizePerPage?: number;
  /** @format int32 */
  total?: number;
}

/**
 * OrderSkuFeeNumber
 * 订单商品行费用
 */
export interface OrderSkuFeeNumber {
  /**
   * 異常回数&&异常次数
   * @format int32
   */
  abnormalCount?: number;
  /**
   * 異常日付&&异常日期
   * @format date-time
   */
  abnormalDate?: string;
  /**
   * 異常数量&&异常数量
   * @format int32
   */
  abnormalNum?: number;
  /**
   * 国際送料追加請求総額日付&&国际运费追加请求总额日期
   * @format date-time
   */
  additionalChargeInternationalShippingDate?: string;
  /** 国際送料追加請求総額&&国际运费追加请求总额 */
  additionalChargeInternationalShippingFee?: number;
  /** 国際送料追加請求総額（為替）&&国际运费追加请求总额（汇率） */
  additionalChargeInternationalShippingRate?: number;
  /**
   * 重量差による追加請求金額日付&&重量差追加请求金额日期
   * @format date-time
   */
  additionalChargeWeightDiffDate?: string;
  /** 重量差による追加請求金額&&重量差追加请求金额 */
  additionalChargeWeightDiffFee?: number;
  /** 重量差による追加請求金額（為替）&&重量差追加请求金额（汇率） */
  additionalChargeWeightDiffRate?: number;
  /**
   * キャンセル済回数&&已取消次数
   * @format int32
   */
  cancelledCount?: number;
  /**
   * キャンセル済日付&&已取消日期
   * @format date-time
   */
  cancelledDate?: string;
  /**
   * キャンセル済数量&&已取消数量
   * @format int32
   */
  cancelledNum?: number;
  /** カラー&&颜色 */
  color?: string;
  /** お客様注文番号&&客户订单号 */
  customerOrderNo?: string;
  /**
   * 不良品回数&&不良品次数
   * @format int32
   */
  defectiveProductCount?: number;
  /**
   * 不良品日付&&不良品日期
   * @format date-time
   */
  defectiveProductDate?: string;
  /**
   * 不良品数量&&不良品数量
   * @format int32
   */
  defectiveProductNum?: number;
  /** 追跡番号&&追踪单号 */
  deliveryTaskCode?: string;
  /**
   * 国際発送日&&国际发货日期
   * @format date-time
   */
  deliveryTime?: string;
  /**
   * 国内運送中回数&&国内运输中次数
   * @format int32
   */
  domesticShippingCount?: number;
  /**
   * 国内運送中日付&&国内运输中日期
   * @format date-time
   */
  domesticShippingDate?: string;
  /** 中国国内送料&&中国国内运费 */
  domesticShippingFee?: number;
  /** 中国国内送料（為替）&&中国国内运费（汇率） */
  domesticShippingFeeRate?: number;
  /**
   * 中国国内送料日付&&中国国内运费日期
   * @format date-time
   */
  domesticShippingFeeRateDate?: string;
  /**
   * 国内運送中数量&&国内运输中数量
   * @format int32
   */
  domesticShippingNum?: number;
  /** 手数料&&手续费 */
  handlingFee?: number;
  /**
   * 手数料日付&&手续费日期
   * @format date-time
   */
  handlingFeeDate?: string;
  /** 手数料（為替）&&手续费（汇率） */
  handlingFeeRate?: number;
  /**
   * 検品済み回数&&检验完成次数
   * @format int32
   */
  inspectionCompletedCount?: number;
  /**
   * 検品済み日付&&检验完成日期
   * @format date-time
   */
  inspectionCompletedDate?: string;
  /**
   * 検品済み数量&&检验完成数量
   * @format int32
   */
  inspectionCompletedNum?: number;
  /**
   * 検品中回数&&检验中次数
   * @format int32
   */
  inspectionInProgressCount?: number;
  /**
   * 検品中日付&&检验中日期
   * @format date-time
   */
  inspectionInProgressDate?: string;
  /**
   * 検品中数量&&检验中数量
   * @format int32
   */
  inspectionInProgressNum?: number;
  /**
   * 発送用オプション（為替）&&发货用选项（汇率）
   * @format date-time
   */
  internationalShippingAdditionDate?: string;
  /** 国際送料&&国际运费 */
  internationalShippingAdditionFee?: number;
  /** 発送用オプション（為替）&&发货用选项（汇率） */
  internationalShippingAdditionRate?: number;
  /**
   * 国際送料日付&&国际运费日期
   * @format date-time
   */
  internationalShippingDate?: string;
  /** "発送用オプション"&&发货附加项 */
  internationalShippingFee?: number;
  /** 国際送料（為替）&&国际运费（汇率） */
  internationalShippingRate?: number;
  /**
   * 国際送料返金日付&&国际运费退款日期
   * @format date-time
   */
  internationalShippingRefundDate?: string;
  /** 国際送料返金&&国际运费退款 */
  internationalShippingRefundFee?: number;
  /** 国際送料返金（為替）&&国际运费退款（汇率） */
  internationalShippingRefundRate?: number;
  /**
   * 処理中在庫回数&&处理中库存次数
   * @format int32
   */
  inventoryProcessingCount?: number;
  /**
   * 処理中在庫日付&&处理中库存日期
   * @format date-time
   */
  inventoryProcessingDate?: string;
  /**
   * 処理中在庫数量&&处理中库存数量
   * @format int32
   */
  inventoryProcessingNum?: number;
  /**
   * 入庫済み回数&&已入库次数
   * @format int32
   */
  inventoryReceivedCount?: number;
  /**
   * 入庫済み日付&&已入库日期
   * @format date-time
   */
  inventoryReceivedDate?: string;
  /**
   * 入庫済み数量&&已入库数量
   * @format int32
   */
  inventoryReceivedNum?: number;
  /**
   * 在庫保管回数&&库存保管次数
   * @format int32
   */
  inventoryStorageCount?: number;
  /**
   * 在庫保管日付&&库存保管日期
   * @format date-time
   */
  inventoryStorageDate?: string;
  /**
   * 在庫保管数量&&库存保管数量
   * @format int32
   */
  inventoryStorageNum?: number;
  /**
   * 最新の更新日&&最新更新日期
   * @format date-time
   */
  latestUpdateDate?: string;
  /** Lineitem sku&&订单项SKU */
  lineitemSku?: string;
  /**
   * 個数&&数量
   * @format int32
   */
  orderQuantity?: number;
  /**
   * 注文日&&订单日期
   * @format date-time
   */
  orderTime?: string;
  /**
   * 订单类型 1:shopfiy订单，2:样品订单
   * @format int32
   */
  orderType?: number;
  /** THE CKB注文番号&&THE CKB订单号 */
  platformOrderNo?: string;
  /** 商品オプション&&商品选项 */
  productAdditionFee?: number;
  /**
   * 商品オプション日付&&商品选项日期
   * @format date-time
   */
  productAdditionFeeDate?: string;
  /** 商品オプション（為替）&&商品选项（汇率） */
  productAdditionFeeRate?: number;
  /** 商品代金&&商品金额 */
  productFee?: number;
  /**
   * 商品代金日付&&商品金额日期
   * @format date-time
   */
  productFeeDate?: string;
  /** 商品代金（為替）&&商品金额（汇率） */
  productFeeRate?: number;
  /** THE CKB SKU&&THE CKB SKU */
  productSku?: string;
  /** 商品名&&商品名称 */
  productTitleJp?: string;
  /**
   * 買付完了回数&&采购完成次数
   * @format int32
   */
  purchaseCompletedCount?: number;
  /**
   * 買付完了日付&&采购完成日期
   * @format date-time
   */
  purchaseCompletedDate?: string;
  /**
   * 買付完了数量&&采购完成数量
   * @format int32
   */
  purchaseCompletedNum?: number;
  /**
   * 買付対応中回数&&采购处理中次数
   * @format int32
   */
  purchaseInProgressCount?: number;
  /**
   * 買付対応中日付&&采购处理中日期
   * @format date-time
   */
  purchaseInProgressDate?: string;
  /**
   * 買付対応中数量&&采购处理中数量
   * @format int32
   */
  purchaseInProgressNum?: number;
  /**
   * 買付待ち回数&&待采购次数
   * @format int32
   */
  purchasePendingCount?: number;
  /**
   * 買付待ち日付&&待采购日期
   * @format date-time
   */
  purchasePendingDate?: string;
  /**
   * 買付待ち数量&&待采购数量
   * @format int32
   */
  purchasePendingNum?: number;
  /** 受取人名&&收件人姓名 */
  receiveName?: string;
  /** 電話番号&&电话号码 */
  receiveTel?: string;
  /**
   * 発送済み回数&&已发货次数
   * @format int32
   */
  shipmentCompletedCount?: number;
  /**
   * 発送済み日付&&已发货日期
   * @format date-time
   */
  shipmentCompletedDate?: string;
  /**
   * 発送済み数量&&已发货数量
   * @format int32
   */
  shipmentCompletedNum?: number;
  /**
   * 発送待ち回数&&待发货次数
   * @format int32
   */
  shipmentPendingCount?: number;
  /**
   * 発送待ち日付&&待发货日期
   * @format date-time
   */
  shipmentPendingDate?: string;
  /**
   * 発送待ち数量&&待发货数量
   * @format int32
   */
  shipmentPendingNum?: number;
  /** Shopify_注文番号&&Shopify订单号 */
  shopifyOrderNo?: string;
  /** Shopify_SKU&&Shopify SKU */
  shopifySku?: string;
  /** サイズ&&尺寸 */
  size?: string;
  /**
   * 国際送料合計日付&&国际运费合计日期
   * @format date-time
   */
  totalInternationalShippingDate?: string;
  /** 国際送料合計&&国际运费合计 */
  totalInternationalShippingFee?: number;
  /** 国際送料合計（為替）&&国际运费合计（汇率） */
  totalInternationalShippingRate?: number;
}

/**
 * OrderSkuFeeNumberDetailsRequestDTO
 * 获取订单商品行费用数量明细参数
 */
export interface OrderSkuFeeNumberDetailsRequestDTO {
  /** app key */
  appKey: string;
  /**
   * 订单类型：1：shopfiy订单，2：样品单
   * @format int32
   */
  orderType?: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageNo: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageSize: number;
  /** 平台订单编码 */
  platformOrderNo?: string;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/**
 * OrderSkuFeeNumberDetailsRespDTO
 * 订单商品行费用及数量明细
 */
export interface OrderSkuFeeNumberDetailsRespDTO {
  /** 订单商品行费用及数量列表 */
  orderSkuFeeNumbers?: OrderSkuFeeNumber[];
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  sizePerPage?: number;
  /** @format int32 */
  total?: number;
}

/**
 * OrderSkuStockFee
 * 直发订单商品行囤货单费用
 */
export interface OrderSkuStockFee {
  /** 国際送料追加請求総額&&国际运费追加请求总额 */
  additionalChargeInternationalShippingFee?: number;
  /** 重量差による追加請求金額&&重量差追加请求金额 */
  additionalChargeWeightDiffFee?: number;
  /** カラー&&颜色 */
  color?: string;
  /** お客様注文番号&&客户订单号 */
  customerOrderNo?: string;
  /** 追跡番号&&追踪单号 */
  deliveryTaskCode?: string;
  /**
   * 国際発送日&&国际发货日期
   * @format date-time
   */
  deliveryTime?: string;
  /** 中国国内送料&&中国国内运费 */
  domesticShippingFee?: number;
  /** 手数料&&手续费 */
  handlingFee?: number;
  /** 国際送料&&国际运费 */
  internationalShippingAdditionFee?: number;
  /** "発送用オプション"&&发货附加项 */
  internationalShippingFee?: number;
  /** 国際送料返金&&国际运费退款 */
  internationalShippingRefundFee?: number;
  /**
   * 最新の更新日&&最新更新日期
   * @format date-time
   */
  latestUpdateDate?: string;
  /** Lineitem sku&&订单项SKU */
  lineitemSku?: string;
  /**
   * 個数&&数量
   * @format int32
   */
  orderQuantity?: number;
  /**
   * 注文日&&订单日期
   * @format date-time
   */
  orderTime?: string;
  /** THE CKB注文番号&&THE CKB订单号 */
  platformOrderNo?: string;
  /** 商品オプション&&商品选项 */
  productAdditionFee?: string;
  /** 商品代金&&商品金额 */
  productFee?: number;
  /** THE CKB SKU&&THE CKB SKU */
  productSku?: string;
  /** 商品名&&商品名称 */
  productTitleJp?: string;
  /** 受取人名&&收件人姓名 */
  receiveName?: string;
  /** 電話番号&&电话号码 */
  receiveTel?: string;
  /** Shopify_注文番号&&Shopify订单号 */
  shopifyOrderNo?: string;
  /** Shopify_SKU&&Shopify SKU */
  shopifySku?: string;
  /** サイズ&&尺寸 */
  size?: string;
  /** 囤货THE CKB注文番号&&囤货THE CKB订单号 */
  stockPlatformOrderNo?: string;
  /** 国際送料合計&&国际运费合计 */
  totalInternationalShippingFee?: number;
}

/**
 * OrderSkuStockFeeDetailsRequestDTO
 * 获取订单商品行囤货单费用明细参数
 */
export interface OrderSkuStockFeeDetailsRequestDTO {
  /**
   * paging Amount per Page
   * @format int32
   */
  pageNo: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageSize: number;
  /** 平台订单编码 */
  platformOrderNo?: string;
}

/**
 * OrderSkuStockFeeDetailsRespDTO
 * 直发订单商品行囤货单费用明细
 */
export interface OrderSkuStockFeeDetailsRespDTO {
  orderSkuStockFees?: OrderSkuStockFee[];
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  sizePerPage?: number;
  /** @format int32 */
  total?: number;
}

/** PackageDimensions */
export interface PackageDimensions {
  height?: string;
  length?: string;
  unit?: string;
  width?: string;
}

/** PackageWeight */
export interface PackageWeight {
  unit?: string;
  value?: string;
}

/**
 * Pallet
 * Pallet information.
 */
export interface Pallet {
  /** The dimensions of the pallet. Length and width must be 40 inches by 48 inches. Height must be less than or equal to 60 inches. */
  dimensions: Dimensions;
  /** Indicates whether pallets will be stacked when carrier arrives for pick-up. */
  isStacked: boolean;
  /** The weight of the pallet. */
  weight?: Weight;
}

/**
 * PartneredLtlDataInput
 * Information that is required by an Amazon-partnered carrier to ship a Less Than Truckload/Full Truckload (LTL/FTL) inbound shipment.
 */
export interface PartneredLtlDataInput {
  /**
   * The number of boxes in the shipment.
   * @format int32
   */
  boxCount?: number;
  /** Contact information for the person in the seller's organization who is responsible for the shipment. Used by the carrier if they have questions about the shipment. */
  contact?: Contact;
  /** The date that the shipment will be ready to be picked up by the carrier. */
  freightReadyDate?: string;
  palletList?: Pallet[];
  /** The declaration of the total value of the inventory in the shipment. */
  sellerDeclaredValue?: Amount;
  sellerFreightClass?:
    | "50"
    | "55"
    | "60"
    | "65"
    | "70"
    | "77.5"
    | "85"
    | "92.5"
    | "100"
    | "110"
    | "125"
    | "150"
    | "175"
    | "200"
    | "250"
    | "300"
    | "400"
    | "500";
  /** The total weight of the shipment. */
  totalWeight?: Weight;
}

/**
 * PartneredSmallParcelDataInput
 * Information that is required by an Amazon-partnered carrier to ship a Small Parcel inbound shipment.
 */
export interface PartneredSmallParcelDataInput {
  /** The Amazon-partnered carrier to use for the inbound shipment. */
  carrierName?: string;
  packageList?: PartneredSmallParcelPackageInput[];
}

/**
 * PartneredSmallParcelPackageInput
 * Dimension and weight information for the package.
 */
export interface PartneredSmallParcelPackageInput {
  /** The dimension values and unit of measurement. */
  dimensions: Dimensions;
  /** The weight of the package. */
  weight: Weight;
}

/** PlatformItemSkuResp */
export interface PlatformItemSkuResp {
  /** @format int64 */
  oemProductClassificationId?: number;
  productCode?: string;
  productCountry?: string;
  productPropertiesName?: string;
  productSku?: string;
  productSkuImg?: string;
  productTitle?: string;
  /** @format int32 */
  productType?: number;
  purchaseCountry?: string;
  /** @format int64 */
  searchSourceOrderId?: number;
  searchSourceOrderNo?: string;
}

/** PlatformLogisticsResp */
export interface PlatformLogisticsResp {
  bizId?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  customerShopPlatform?: number;
  name?: string;
  /** @format int64 */
  platformLogisticsId?: number;
  /** @format date-time */
  updateTime?: string;
}

/** PlatformOrderVO */
export interface PlatformOrderVO {
  /** @format int64 */
  platformOrderId?: number;
  platformOrderNo?: string;
}

/** PrepCategoryClass */
export interface PrepCategoryClass {
  desc?: string;
  descJa?: string;
  value?: string;
}

/**
 * PrepDetails
 * Preparation instructions and who is responsible for the preparation.
 */
export interface PrepDetails {
  prepInstruction: "Polybagging" | "BubbleWrapping" | "Taping" | "BlackShrinkWrapping" | "Labeling" | "HangGarment";
  prepOwner: "AMAZON" | "SELLER";
}

/**
 * ProductAmountDetail
 * 商品金额明细
 */
export interface ProductAmountDetail {
  /** 未入库商品金额 */
  noStockAmount?: number;
  /**
   * 未入库数量
   * @format int64
   */
  noStockQuantity?: number;
  /** 产品名称 */
  productName?: string;
  /** 订单商品明细 */
  productOrderAmountDetailList?: ProductOrderAmountDetail[];
  /** 平台SKU */
  productSku?: string;
  /** 发货商品金额 */
  shipAmount?: number;
  /**
   * 已发货数量
   * @format int64
   */
  shipQuantity?: number;
  /** 在库商品总金额 */
  stockAmount?: number;
  /**
   * 在库数量
   * @format int64
   */
  stockQuantity?: number;
  /** 商品总金额 */
  totalAmount?: number;
  /**
   * 商品总数量
   * @format int64
   */
  totalQuantity?: number;
}

/** ProductCustoms */
export interface ProductCustoms {
  compilationMethod?: string;
  compilationMethodEn?: string;
  customsCode?: string;
  customsPriceJp?: number;
  /** @format int64 */
  productCustomsId?: number;
  productItemCategoryEn?: string;
  productItemCategoryZh?: string;
  simpleReportCode?: string;
}

/**
 * ProductOrderAmountDetail
 * 订单商品金额明细
 */
export interface ProductOrderAmountDetail {
  /** 未入库商品金额 */
  noStockAmount?: number;
  /**
   * 未入库数量
   * @format int64
   */
  noStockQuantity?: number;
  /** 平台订单号 */
  platformOrderNo?: string;
  /** 产品名称 */
  productName?: string;
  /** 平台SKU */
  productSku?: string;
  /** 发货商品金额 */
  shipAmount?: number;
  /**
   * 已发货数量
   * @format int64
   */
  shipQuantity?: number;
  /** 在库商品总金额 */
  stockAmount?: number;
  /**
   * 在库数量
   * @format int64
   */
  stockQuantity?: number;
  /** 商品总金额 */
  totalAmount?: number;
  /**
   * 商品总数量
   * @format int64
   */
  totalQuantity?: number;
}

/** PublishItemToShopRequest */
export interface PublishItemToShopRequest {
  categoryId?: string;
  imageUrls?: Record<string, string>;
  languageCode?: string;
  packageDimensions?: PackageDimensions;
  packageWeight?: PackageWeight;
  productCode?: string;
  /** @format int32 */
  purchaseChannel?: number;
}

/** PullCrossMallOrderRequest */
export interface PullCrossMallOrderRequest {
  currentPhaseName?: string;
  /** @format date-time */
  endTime?: string;
  phaseName?: string[];
  /** @format date-time */
  startTime?: string;
  syncBatchNo?: string;
  /** @format int32 */
  syncSource?: number;
}

/** PutTransportDetailsReq */
export interface PutTransportDetailsReq {
  /** @format int64 */
  customerShopId?: number;
  planNo?: string;
  /** The request schema for a putTransportDetails operation. */
  request?: PutTransportDetailsRequest;
  shipmentId?: string;
}

/**
 * PutTransportDetailsRequest
 * The request schema for a putTransportDetails operation.
 */
export interface PutTransportDetailsRequest {
  /** Indicates whether a putTransportDetails request is for an Amazon-partnered carrier. */
  isPartnered: boolean;
  shipmentType: "SP" | "LTL";
  /** Information required to create an Amazon-partnered carrier shipping estimate, or to alert the Amazon fulfillment center to the arrival of an inbound shipment by a non-Amazon-partnered carrier. */
  transportDetails: TransportDetailInput;
}

/** PutTransportDetailsResp */
export interface PutTransportDetailsResp {
  commonTransportResult?: CommonTransportResult;
  /** A list of error responses returned when a request is unsuccessful. */
  errorList?: ErrorList;
}

/** QueryAmazonProductReq */
export interface QueryAmazonProductReq {
  amazonMskus?: string[];
  /** @format int64 */
  customerShopId?: number;
}

/** QueryAmazonProductRequest */
export interface QueryAmazonProductRequest {
  amazonMskuList?: string[];
  /** @format int64 */
  customerShopId?: number;
  labelOwner?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  preCategory?: string;
  prepOwner?: string;
  productName?: string;
}

/** QueryBindGoodsReqDTO */
export interface QueryBindGoodsReqDTO {
  /**
   * 用户店铺表id
   * @format int64
   */
  customerShopId?: number;
  flowTable?: string;
  overSeasInboundItemTable?: string;
  overSeasInboundOrderTable?: string;
  overSeasStockTable?: string;
  platformOrderItemTable?: string;
  platformOrderTable?: string;
  regularizationTable?: string;
  shopItemSkuMappingTable?: string;
  shopItemSkuTable?: string;
  shopItemTable?: string;
  shopOrderItemTable?: string;
  shopOrderTable?: string;
  shopProductSkuTable?: string;
  stockTable?: string;
  /** 三方sku编码 */
  thirdSkuCode?: string;
}

/** QueryBindGoodsRespDTO */
export interface QueryBindGoodsRespDTO {
  /**
   * 异常中数量
   * @format int32
   */
  abnormalQuantity?: number;
  /**
   * 良品数
   * @format int32
   */
  availableQuantity?: number;
  /**
   * 检品中数量
   * @format int32
   */
  checkingQuantity?: number;
  /**
   * 用户店铺表id
   * @format int64
   */
  customerShopId?: number;
  /**
   * 运输中数量
   * @format int32
   */
  expressQuantity?: number;
  /**
   * 利用予定数
   * @format int32
   */
  freezeQuantity?: number;
  /**
   * 历史已采购数量
   * @format int32
   */
  historyPurchasedQuantity?: number;
  /**
   * 处理中数量
   * @format int32
   */
  pendingQuantity?: number;
  /** 二级类目编码 */
  productCategoryFrontendNdId?: string;
  /** 平台商品编码 */
  productCode?: string;
  /** 详情URL */
  productDetailUrl?: string;
  /** 主图 */
  productMainImg?: string;
  /** 平台属性名称 */
  productPropertiesName?: string;
  /** 平台商品SKU */
  productSku?: string;
  /** 平台商品名称 */
  productTitle?: string;
  /**
   * 商品类型 1：普通商品，2：OEM商品，3：组合商品
   * @format int32
   */
  productType?: number;
  /**
   * 已采购数量
   * @format int32
   */
  purchasedQuantity?: number;
  /**
   * 采购中数量
   * @format int32
   */
  purchasingQuantity?: number;
  /**
   * oem寻源类型
   * @format int64
   */
  searchSourceOrderId?: number;
  /** oem寻源类型 */
  searchSourceOrderNo?: string;
  /**
   * oem寻源类型
   * @format int32
   */
  searchSourceOrderRepurchaseApplyId?: number;
  /**
   * 入库中数量
   * @format int32
   */
  stockInQuantity?: number;
  /** 组合子商品信息 */
  subProductList?: CombinationSubProduct[];
  /** 第三方商品属性 */
  thirdItemAttribute?: string;
  /** 第三方商品编码 */
  thirdItemCode?: string;
  /** 第三方商品标题 */
  thirdItemName?: string;
  /** 第三方规格编码 */
  thirdSkuCode?: string;
  /**
   * 返品不可不良品数
   * @format int32
   */
  unableDefectiveQuantity?: number;
  /**
   * 待采购数量
   * @format int32
   */
  waitPurchaseQuantity?: number;
}

/** QueryCrossMallProductReq */
export interface QueryCrossMallProductReq {
  crossMallProductSkus?: string[];
  /** @format int64 */
  customerShopId?: number;
}

/** QueryCrossMallProductRequest */
export interface QueryCrossMallProductRequest {
  crossMallSkuList?: string[];
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  productCode?: string;
  productName?: string;
  /** @format int32 */
  status?: number;
}

/** QueryOrderCountRespDTO */
export interface QueryOrderCountRespDTO {
  /** @format int32 */
  createOrderNum?: number;
  /** @format int32 */
  noCreateOrderNum?: number;
}

/** QueryShopOrderRequest */
export interface QueryShopOrderRequest {
  country?: string;
  /** @format int32 */
  mappingStatus?: number;
  orderName?: string;
  orderNames?: string[];
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  province?: string;
  /** @format int32 */
  queryType?: number;
  receiveName?: string;
  /** @format date-time */
  shopOrderEndTime?: string;
  shopOrderNo?: string;
  shopOrderNos?: string[];
  /** @format date-time */
  shopOrderStartTime?: string;
  /** @format int32 */
  tiktokOrderFlag?: number;
  tiktokOrderNo?: string;
  tiktokOrderNos?: string[];
}

/** QueryWaitReplenishOrderRequest */
export interface QueryWaitReplenishOrderRequest {
  /** 客户商品sku */
  customerProductSku?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 商品名称 */
  productName?: string;
  /** 平台商品sku */
  productSku?: string;
  /**
   * 商品状态 1:已匹配 2:匹配预定 3:待匹配
   * @format int32
   */
  productStatus?: number;
  /** 采购国家 CN:中国 JP:日本 */
  purchaseCountry?: string;
  queryObj?: object;
  /** 收件人 */
  receiveName?: string;
  /** 店铺订单编号 */
  shopOrderNo?: string;
}

/** Receiver */
export interface Receiver {
  /** receiver detail address */
  address: string;
  /** city */
  city: string;
  /** country code，Japan: JP */
  countryCode: string;
  /** receiver email */
  email?: string;
  /** receiver name */
  name: string;
  /** receiver phone */
  phone: string;
  /** postal code */
  postalCode: string;
  /** prefectures */
  province: string;
}

/** RemoveAmazonProductRequest */
export interface RemoveAmazonProductRequest {
  amazonMsku?: string;
}

/** RemoveCrossMallProductRequest */
export interface RemoveCrossMallProductRequest {
  crossMallSku?: string;
}

/** ReplenishPlanAddressResp */
export interface ReplenishPlanAddressResp {
  address?: string;
  /** @format int32 */
  addressType?: number;
  area?: string;
  city?: string;
  clubCode?: string;
  companyName?: string;
  email?: string;
  mobile?: string;
  name?: string;
  nation?: string;
  postalCode?: string;
  province?: string;
  /** @format int64 */
  replenishPlanAddressId?: number;
  /** @format int64 */
  replenishPlanId?: number;
  replenishPlanNo?: string;
}

/** ReplenishPlanItemResp */
export interface ReplenishPlanItemResp {
  amazonAsin?: string;
  amazonFnsku?: string;
  amazonMsku?: string;
  amazonProductTitle?: string;
  /** @format int32 */
  deliveryNums?: number;
  overseaProductSku?: string;
  productImg?: string;
  productSku?: string;
  productTitle?: string;
  /** @format int64 */
  replenishPlanId?: number;
  /** @format int64 */
  replenishPlanItemId?: number;
  replenishPlanNo?: string;
  shopProductSku?: string;
}

/** ReplenishPlanListReq */
export interface ReplenishPlanListReq {
  customerShopIds?: number[];
  /** @format int32 */
  planStatus?: number;
  replenishPlanIds?: number[];
}

/** ReplenishPlanResp */
export interface ReplenishPlanResp {
  addressList?: ReplenishPlanAddressResp[];
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  deliveryTaskCode?: string;
  forwarder?: string;
  intForwarderConfigId?: string;
  /** @format int64 */
  intShipConfigId?: number;
  /** @format int32 */
  planStatus?: number;
  receiverWarehouse?: string;
  /** @format int64 */
  replenishPlanId?: number;
  replenishPlanItemList?: ReplenishPlanItemResp[];
  replenishPlanNo?: string;
  shipmentId?: string;
  shippingType?: string;
  shippingTypeJp?: string;
  title?: string;
  unificationCustomerFullName?: string;
}

/** ResourceDTO */
export interface ResourceDTO {
  app_name?: string;
  client_id?: string;
  deleted_date?: string;
  mall_id?: string;
}

/** ResponseEntity */
export interface ResponseEntity {
  body?: object;
  statusCode?:
    | "100 CONTINUE"
    | "101 SWITCHING_PROTOCOLS"
    | "102 PROCESSING"
    | "103 CHECKPOINT"
    | "200 OK"
    | "201 CREATED"
    | "202 ACCEPTED"
    | "203 NON_AUTHORITATIVE_INFORMATION"
    | "204 NO_CONTENT"
    | "205 RESET_CONTENT"
    | "206 PARTIAL_CONTENT"
    | "207 MULTI_STATUS"
    | "208 ALREADY_REPORTED"
    | "226 IM_USED"
    | "300 MULTIPLE_CHOICES"
    | "301 MOVED_PERMANENTLY"
    | "302 FOUND"
    | "302 MOVED_TEMPORARILY"
    | "303 SEE_OTHER"
    | "304 NOT_MODIFIED"
    | "305 USE_PROXY"
    | "307 TEMPORARY_REDIRECT"
    | "308 PERMANENT_REDIRECT"
    | "400 BAD_REQUEST"
    | "401 UNAUTHORIZED"
    | "402 PAYMENT_REQUIRED"
    | "403 FORBIDDEN"
    | "404 NOT_FOUND"
    | "405 METHOD_NOT_ALLOWED"
    | "406 NOT_ACCEPTABLE"
    | "407 PROXY_AUTHENTICATION_REQUIRED"
    | "408 REQUEST_TIMEOUT"
    | "409 CONFLICT"
    | "410 GONE"
    | "411 LENGTH_REQUIRED"
    | "412 PRECONDITION_FAILED"
    | "413 PAYLOAD_TOO_LARGE"
    | "413 REQUEST_ENTITY_TOO_LARGE"
    | "414 URI_TOO_LONG"
    | "414 REQUEST_URI_TOO_LONG"
    | "415 UNSUPPORTED_MEDIA_TYPE"
    | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
    | "417 EXPECTATION_FAILED"
    | "418 I_AM_A_TEAPOT"
    | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
    | "420 METHOD_FAILURE"
    | "421 DESTINATION_LOCKED"
    | "422 UNPROCESSABLE_ENTITY"
    | "423 LOCKED"
    | "424 FAILED_DEPENDENCY"
    | "425 TOO_EARLY"
    | "426 UPGRADE_REQUIRED"
    | "428 PRECONDITION_REQUIRED"
    | "429 TOO_MANY_REQUESTS"
    | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
    | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
    | "500 INTERNAL_SERVER_ERROR"
    | "501 NOT_IMPLEMENTED"
    | "502 BAD_GATEWAY"
    | "503 SERVICE_UNAVAILABLE"
    | "504 GATEWAY_TIMEOUT"
    | "505 HTTP_VERSION_NOT_SUPPORTED"
    | "506 VARIANT_ALSO_NEGOTIATES"
    | "507 INSUFFICIENT_STORAGE"
    | "508 LOOP_DETECTED"
    | "509 BANDWIDTH_LIMIT_EXCEEDED"
    | "510 NOT_EXTENDED"
    | "511 NETWORK_AUTHENTICATION_REQUIRED";
  /** @format int32 */
  statusCodeValue?: number;
}

/** SearchOrdersReq */
export interface SearchOrdersReq {
  /**
   * 创建时间结束
   * @format date-time
   */
  createdAtMax?: string;
  /**
   * 创建时间开始
   * @format date-time
   */
  createdAtMin?: string;
  /** @format int64 */
  customerShopId?: number;
  /** 支付状态---所有:any,已支付订单:paid,未支付订单:unpaid,已作废的订单:voided,在审核的订单:pending,已退款的订单:refunded,已授权的订单:authorized,部分支付订单:partially_paid,部分退款订单:partially_refunded; */
  financialStatus?: string;
  /** 物流状态---所有:any,部分发货订单:partial, 已发货和部分发货:shipped,未发货和部分发货:unshipped,未履行:unfulfilled,已履行:fulfilled; */
  fulfillmentStatus?: string;
  /** 订单状态---所有:any,未完结的订单:open,已关闭的订单:closed,已取消的订单:cancelled; */
  status?: string;
  /**
   * 更新时间结束
   * @format date-time
   */
  updatedAtMax?: string;
  /**
   * 更新时间开始
   * @format date-time
   */
  updatedAtMin?: string;
}

/** SearchProductsReq */
export interface SearchProductsReq {
  amazonAll?: boolean;
  /**
   * 创建时间结束
   * @format date-time
   */
  createdAtMax?: string;
  /**
   * 创建时间开始
   * @format date-time
   */
  createdAtMin?: string;
  /** @format int64 */
  customerShopId?: number;
  /**
   * 发布时间结束
   * @format date-time
   */
  publishedAtMax?: string;
  /**
   * 发布时间开始
   * @format date-time
   */
  publishedAtMin?: string;
  /** 发布状态：any：已发布；published：已发布；unpublished：未发布 */
  publishedStatus?: string;
  /** 商品状态：active：活跃；archived：存档，不再销售；draft：草稿，重复和未归档的产品设置为草稿 */
  status?: string;
  /** 商品名称 */
  title?: string;
  /**
   * 更新时间结束
   * @format date-time
   */
  updatedAtMax?: string;
  /**
   * 更新时间开始
   * @format date-time
   */
  updatedAtMin?: string;
}

/** SearchSourceOrder */
export interface SearchSourceOrder {
  /** @format int32 */
  addLogoFlag?: number;
  /** @format int32 */
  containTaxFlag?: number;
  /** @format int32 */
  customerExpectMinOrderQuantity?: number;
  customerSamplePrice?: number;
  defectiveDealMode?: string;
  defectiveDealModeJp?: string;
  /** @format int32 */
  deliveryPeriod?: number;
  fabric?: string;
  fabricJp?: string;
  fillSellPriceRemark?: string;
  gradientPrices?: GradientPrice[];
  /** @format int32 */
  minOrderQuantity?: number;
  /** @format int64 */
  oemSupplierId?: number;
  /** @format date-time */
  priceExpireTime?: string;
  productImg?: string;
  productName?: string;
  productNameZh?: string;
  productUrl?: string;
  purchaserUserName?: string;
  reportPurchasePriceRemark?: string;
  reportPurchasePriceRemarkJp?: string;
  risk?: string;
  riskJp?: string;
  samplePeriod?: number;
  samplePrice?: number;
  /** @format int64 */
  searchSourceOrderId?: number;
  searchSourceOrderNo?: string;
  /** @format int64 */
  searchSourceOrderSupplierPriceId?: number;
  /** @format int32 */
  sizeFlag?: number;
  /** @format int32 */
  specialMaterialFlag?: number;
  supplierName?: string;
}

/** SelectShopOrderItemsResp */
export interface SelectShopOrderItemsResp {
  /** @format int32 */
  additionCheckType?: number;
  additionSnapshot?: ThirdShopItemAddition[];
  /** @format int32 */
  bindStatus?: number;
  /** @format int32 */
  brandAuthStatus?: number;
  /** @format int32 */
  brandHasReleased?: number;
  /** @format int64 */
  brandId?: number;
  /** @format int32 */
  brandStatus?: number;
  combinationSubSnapshot?: CombinationSubProduct[];
  /** @format int32 */
  errorCode?: number;
  /** @format int32 */
  freezeQuantity?: number;
  /** @format int32 */
  itemQuantity?: number;
  /** @format int32 */
  onTheWayCancelQuantity?: number;
  /** @format int32 */
  onTheWayFreezeQuantity?: number;
  platformItemSku?: PlatformItemSkuResp;
  /** @format int64 */
  shopOrderId?: number;
  /** @format int64 */
  shopOrderItemId?: number;
  thirdItemSku?: ThirdItemSkuResp;
  thirdPlatformType?:
    | "OTHER"
    | "BASE"
    | "SHOPIFY"
    | "STORES"
    | "AMAZON"
    | "CAFE24"
    | "OPEN"
    | "TIKTOK_SHOP"
    | "CROSSMALL";
  /** @format int32 */
  waitReplenishQuantity?: number;
}

/** ShopFundFlowDetail */
export interface ShopFundFlowDetail {
  /** 钱包余额 */
  afterAvailableAmount?: number;
  /** 资金明细名称，即钱包变动的费用类型描述 */
  bizContentCustomer?: string;
  /** 变更金额 */
  changeAmount?: number;
  /**
   * 流水类型
   * @format int32
   */
  changeType?: number;
  /**
   * 作成日時，流水发生时间
   * @format date-time
   */
  createTime?: string;
  /**
   * 店铺编号
   * @format int64
   */
  customerShopId?: number;
  /** 店铺名称 */
  customerShopName?: string;
  /** 发货单号 */
  deliveryOrderNo?: string;
  /** 汇率 */
  exchangeRate?: number;
  /** 钱包流水单号 */
  fundFlowNo?: string;
  /** 钱包变动的费用类型 */
  fundFlowType?: string;
  /** 钱包变动的日元金额 */
  originalChangeAmount?: number;
  /** 平台订单编号 */
  platformOrderNo?: string;
  /**
   * 店铺类型，1 表示主店铺，2 表示子店铺
   * @format int32
   */
  shopType?: number;
}

/** ShopFundFlowDetailReqDTO */
export interface ShopFundFlowDetailReqDTO {
  /** app key */
  appKey: string;
  /**
   * paging Amount per Page
   * @format int64
   */
  customerShopId: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageNo: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageSize: number;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** ShopFundFlowDetailRespDTO */
export interface ShopFundFlowDetailRespDTO {
  /** @format int32 */
  code?: number;
  data?: ShopFundFlowDetail[];
  message?: string;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  sizePerPage?: number;
  /** @format int32 */
  total?: number;
}

/** ShopStockDetail */
export interface ShopStockDetail {
  /** @format int64 */
  availableQuantity?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  freezeQuantity?: number;
  isIngredients?: boolean;
  /** @format int64 */
  pendingStorage?: number;
  productPropertiesName?: string;
  productSku?: string;
  productTitle?: string;
  /** @format int32 */
  productType?: number;
  shopProductSku?: string;
  /** @format int64 */
  unableProcessDefectiveProducts?: number;
  unitPrice?: number;
}

/** ShopStockDetailReqDTO */
export interface ShopStockDetailReqDTO {
  /** app key */
  appKey: string;
  /**
   * paging Amount per Page
   * @format int64
   */
  customerShopId: number;
  isIngredients?: boolean;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageNo: number;
  /**
   * paging Amount per Page
   * @format int32
   */
  pageSize: number;
  productSku?: string;
  /** @format int32 */
  productType?: number;
  shopProductSku?: string;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** ShopStockDetailRespDTO */
export interface ShopStockDetailRespDTO {
  /** @format int32 */
  code?: number;
  data?: ShopStockDetail[];
  message?: string;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  sizePerPage?: number;
  /** @format int32 */
  total?: number;
}

/** SkuMapping */
export interface SkuMapping {
  mappingInfoList?: MappingInfo[];
  /** @format int64 */
  shopItemSkuId?: number;
}

/** SkuMappingInfo */
export interface SkuMappingInfo {
  /** @format int32 */
  mappingSeq?: number;
  productCode?: string;
  productSku?: string;
  /** @format int32 */
  productType?: number;
}

/** SubmitAdditionReq */
export interface SubmitAdditionReq {
  /** @format int32 */
  additionConfigId?: number;
  /** @format int32 */
  additionId?: number;
  ingredientsSku?: string;
}

/** SyncAmazonProductRequest */
export interface SyncAmazonProductRequest {
  amazonSkuList?: string[];
}

/** SyncCrossMallProductRequest */
export interface SyncCrossMallProductRequest {
  productCodeList?: string[];
}

/** TTSCategoryResp */
export interface TTSCategoryResp {
  id?: string;
  isLeaf?: boolean;
  localName?: string;
  parentId?: string;
  permissionStatuses?: string[];
  ttscategoryResp?: TTSCategoryResp[];
}

/** TaskResp */
export interface TaskResp {
  errorCode?: string;
  errorList?: CreateErrorModel[];
  errorMsg?: string;
  result?: object;
  status?: string;
}

/** TestOrderProcessReq */
export interface TestOrderProcessReq {
  /** @format int64 */
  authShopId?: number;
  orderIdList?: number[];
}

/** ThirdItemSkuResp */
export interface ThirdItemSkuResp {
  itemRemark?: string;
  /** @format int64 */
  shopItemId?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  thirdSkuCode?: string;
}

/** ThirdShopAuth */
export interface ThirdShopAuth {
  accessToken?: string;
  /** @format int64 */
  authExpireTime?: number;
  authStatus?: "CHECK_OK" | "EXPIRED" | "INVALID_TOKEN" | "OTHER_ERROR" | "TOKEN_SCOPE_LACKING";
  cipher?: string;
  clientId?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  nationCode?: string;
  refreshToken?: string;
  /** @format int64 */
  shopAuthId?: number;
  shopExt?: string;
  stationCode?: string;
  status?: "BIND" | "UNBIND";
  thirdPlatformType?:
    | "OTHER"
    | "BASE"
    | "SHOPIFY"
    | "STORES"
    | "AMAZON"
    | "CAFE24"
    | "OPEN"
    | "TIKTOK_SHOP"
    | "CROSSMALL";
  thirdShopId?: string;
  thirdShopName?: string;
  thirdShopUrl?: string;
  /** @format int64 */
  tokenExpireTime?: number;
  wareHouseId?: string;
}

/** ThirdShopAuthBindCheckResp */
export interface ThirdShopAuthBindCheckResp {
  customerShopId?: string;
  hasBind?: boolean;
  shopName?: string;
}

/** ThirdShopAuthBindRequest */
export interface ThirdShopAuthBindRequest {
  accessToken?: string;
  code?: string;
  /** @format int64 */
  customerShopId?: number;
  sellingPartnerId?: string;
  /** @format int32 */
  thirdShopType?: number;
  url?: string;
}

/** ThirdShopAuthBindResp */
export interface ThirdShopAuthBindResp {
  bind?: boolean;
  /** @format int32 */
  thirdPlatformType?: number;
}

/** ThirdShopAuthUnBindRequest */
export interface ThirdShopAuthUnBindRequest {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  thirdShopType?: number;
}

/** ThirdShopInventoryLevel */
export interface ThirdShopInventoryLevel {
  /** @format int64 */
  available?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  inventoryItemId?: number;
  /** @format int32 */
  isDeleted?: number;
  /** @format int64 */
  locationId?: number;
  thirdItemCode?: string;
  thirdSkuCode?: string;
  /** @format date-time */
  updatedAt?: string;
}

/** ThirdShopItem */
export interface ThirdShopItem {
  /** @format int32 */
  additionCheckType?: number;
  additionCheckTypeList?: AdditionCheckTypePojo[];
  additionList?: ThirdShopItemAddition[];
  additions?: AdditionsPojo[];
  /** @format int32 */
  bindingCount?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  flag?: number;
  /** @format int32 */
  hasAddProduct?: number;
  inventoryLevelList?: ThirdShopInventoryLevel[];
  /** @format int64 */
  isDeleted?: number;
  itemExtra?: string;
  itemRemark?: string;
  /** @format int32 */
  needFilter?: number;
  /** @format int64 */
  shopItemId?: number;
  skuList?: ThirdShopItemSku[];
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  thirdItemStatus?: string;
  thirdPlatformType?:
    | "OTHER"
    | "BASE"
    | "SHOPIFY"
    | "STORES"
    | "AMAZON"
    | "CAFE24"
    | "OPEN"
    | "TIKTOK_SHOP"
    | "CROSSMALL";
  thirdSalePrice?: number;
  thirdShopId?: string;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  unbindingCount?: number;
  /** @format date-time */
  updateTime?: string;
}

/** ThirdShopItemAddition */
export interface ThirdShopItemAddition {
  /** @format int32 */
  additionConfigId?: number;
  additionExtra?: ThirdShopItemAdditionExtra;
  additionExtraName?: string;
  /** @format int32 */
  additionId?: number;
  /** @format int64 */
  id?: number;
  ingredientsSku?: string;
  /** @format int64 */
  shopItemId?: number;
  /** @format int32 */
  spotCheckFlag?: number;
  spotCheckRatio?: number;
  warehouseCode?: string;
}

/** ThirdShopItemAdditionExtra */
export interface ThirdShopItemAdditionExtra {
  additionName?: string;
  additionNameJp?: string;
}

/** ThirdShopItemBatchDeleteRequest */
export interface ThirdShopItemBatchDeleteRequest {
  shopItemIds?: number[];
}

/** ThirdShopItemBindRequest */
export interface ThirdShopItemBindRequest {
  productSku?: string;
  /** @format int32 */
  productType?: number;
  /** @format int64 */
  shopItemSkuId?: number;
}

/** ThirdShopItemDeleteRequest */
export interface ThirdShopItemDeleteRequest {
  /** @format int64 */
  shopItemSkuId?: number;
}

/** ThirdShopItemMappingRequest */
export interface ThirdShopItemMappingRequest {
  /** @format int64 */
  shopItemId?: number;
  skuMappingList?: SkuMapping[];
  unbindFlag?: boolean;
}

/** ThirdShopItemMappingResp */
export interface ThirdShopItemMappingResp {
  bindedShopSkuInfoList?: BindedShopSkuInfo[];
  productCode?: string;
  productSku?: string;
  /** @format int32 */
  productType?: number;
}

/** ThirdShopItemQueryRequest */
export interface ThirdShopItemQueryRequest {
  /** @format int32 */
  bindStatus?: number;
  itemRemark?: string;
  itemRemarkList?: string[];
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  productTitle?: string;
  thirdItemName?: string;
}

/** ThirdShopItemResp */
export interface ThirdShopItemResp {
  additionCheckTypeList?: AdditionCheckTypePojo[];
  additions?: AdditionsPojo[];
  /** @format int32 */
  bindingCount?: number;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  hasAddProduct?: number;
  itemRemark?: string;
  /** @format int64 */
  shopItemId?: number;
  skuList?: ThirdShopItemSkuResp[];
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  thirdItemStatus?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSalePrice?: number;
  thirdShopId?: string;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  unbindingCount?: number;
}

/** ThirdShopItemSku */
export interface ThirdShopItemSku {
  /** @format int32 */
  additionCheckType?: number;
  additionList?: ThirdShopItemSkuAddition[];
  bindStatus?: "UNBINDING" | "BINDING" | "BIND_ERROR";
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  inventoryItemId?: number;
  itemRemark?: string;
  /** @format int32 */
  mappingCount?: number;
  /** @format int32 */
  needFilter?: number;
  productCode?: string;
  productSku?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  skuMappingList?: ThirdShopItemSkuMapping[];
  skuPrice?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  thirdPlatformType?:
    | "OTHER"
    | "BASE"
    | "SHOPIFY"
    | "STORES"
    | "AMAZON"
    | "CAFE24"
    | "OPEN"
    | "TIKTOK_SHOP"
    | "CROSSMALL";
  thirdSalePrice?: number;
  thirdSkuCode?: string;
  thirdSkuExtra?: string;
  thirdSkuImage?: string;
  /** @format int32 */
  thirdStock?: number;
  unifiedPlatformProduct?: UnifiedPlatformProduct;
  /** @format date-time */
  updateTime?: string;
  variationIdentifier?: string;
}

/** ThirdShopItemSkuAddition */
export interface ThirdShopItemSkuAddition {
  /** @format int32 */
  additionConfigId?: number;
  additionExtra?: ThirdShopItemAdditionExtra;
  additionExtraName?: string;
  /** @format int32 */
  additionId?: number;
  /** @format int64 */
  id?: number;
  ingredientsSku?: string;
  /** @format int64 */
  shopItemSkuId?: number;
  /** @format int32 */
  spotCheckFlag?: number;
  spotCheckRatio?: number;
  warehouseCode?: string;
}

/** ThirdShopItemSkuMapping */
export interface ThirdShopItemSkuMapping {
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  id?: number;
  /** @format int32 */
  isDeleted?: number;
  /** @format int32 */
  mappingSeq?: number;
  productCode?: string;
  productCountry?: string;
  productSku?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemCode?: string;
  thirdPlatformType?:
    | "OTHER"
    | "BASE"
    | "SHOPIFY"
    | "STORES"
    | "AMAZON"
    | "CAFE24"
    | "OPEN"
    | "TIKTOK_SHOP"
    | "CROSSMALL";
  thirdSkuCode?: string;
  /** @format date-time */
  updateTime?: string;
}

/** ThirdShopItemSkuMappingResp */
export interface ThirdShopItemSkuMappingResp {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  mappingSeq?: number;
  productCode?: string;
  productSku?: string;
  /** @format int32 */
  productType?: number;
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemCode?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSkuCode?: string;
}

/** ThirdShopItemSkuResp */
export interface ThirdShopItemSkuResp {
  /** @format int32 */
  additionCheckType?: number;
  /** @format int32 */
  bindStatus?: number;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  itemRemark?: string;
  /** @format int32 */
  mappingCount?: number;
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSalePrice?: number;
  thirdSkuCode?: string;
  thirdSkuImage?: string;
}

/** ThirdShopItemUnbindRequest */
export interface ThirdShopItemUnbindRequest {
  /** @format int64 */
  shopItemSkuId?: number;
}

/** ThirdShopOrder */
export interface ThirdShopOrder {
  allUnBindFlag?: boolean;
  /** @format int32 */
  combinedOrder?: number;
  /** @format int32 */
  createOrderNum?: number;
  currency?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  deliveryAdditionList?: ThirdShopOrderDeliveryAddition[];
  deliveryAdditions?: DeliveryAdditionsPojo[];
  distribution?: string;
  errorCode?: string;
  errorMsg?: string;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  intShipConfigId?: number;
  intShipConfigList?: IntShipConfigPojo[];
  /** @format int32 */
  isDeleted?: number;
  /** @format int32 */
  isReturnLogisticsNo?: number;
  /** @format int32 */
  itemQuantity?: number;
  metadata?: string;
  /** @format int32 */
  mutiWareHouseDelivery?: number;
  /** @format int32 */
  needFilter?: number;
  /** @format int32 */
  noCreateOrderNum?: number;
  orderAmount?: number;
  orderItems?: ThirdShopOrderItem[];
  orderSyncStatus?: "NOT_CREATE_ORDER" | "CREATE_ORDER_SUCCESS" | "CREATE_ORDERING" | "CREATE_ORDER_FAIL";
  partBindFlag?: boolean;
  /** @format int32 */
  payStatus?: number;
  /** @format int64 */
  platformOrderId?: number;
  platformOrderList?: PlatformOrderVO[];
  platformOrderNo?: string;
  priceFloatPercent?: number;
  productCountries?: string[];
  receiver?: ThirdShopOrderReceiver;
  /** @format int64 */
  rtsSlaTime?: number;
  /** @format int32 */
  sampleOrder?: number;
  /** @format int64 */
  shopOrderId?: number;
  /** @format date-time */
  shopOrderTime?: string;
  thirdOrderName?: string;
  thirdOrderNo?: string;
  thirdOrderStatus?: string;
  thirdPlatformType?:
    | "OTHER"
    | "BASE"
    | "SHOPIFY"
    | "STORES"
    | "AMAZON"
    | "CAFE24"
    | "OPEN"
    | "TIKTOK_SHOP"
    | "CROSSMALL";
  thirdShopId?: string;
  /** @format int32 */
  tiktokOrderFlag?: number;
  tiktokOrderId?: string;
}

/** ThirdShopOrderDeliveryAddition */
export interface ThirdShopOrderDeliveryAddition {
  /** @format int32 */
  additionCode?: number;
  /** @format int32 */
  additionConfigId?: number;
  /** @format int32 */
  additionId?: number;
  additionName?: string;
  additionNameJp?: string;
  ingredientsName?: string;
  ingredientsNameJp?: string;
  ingredientsSku?: string;
  /** @format int64 */
  shopOrderId?: number;
  warehouseCode?: string;
}

/** ThirdShopOrderItem */
export interface ThirdShopOrderItem {
  /** @format int32 */
  additionCheckType?: number;
  additionSnapshot?: ThirdShopItemAddition[];
  combinationSubSnapshot?: string;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  needFilter?: number;
  platformOrderNo?: string;
  productCode?: string;
  productCountry?: string;
  productSku?: string;
  productSnapshot?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  /** @format int64 */
  searchSourceOrderId?: number;
  searchSourceOrderNo?: string;
  /** @format int32 */
  shipmentStatus?: number;
  /** @format int64 */
  shopOrderId?: number;
  /** @format int64 */
  shopOrderItemId?: number;
  thirdItemAmount?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  /** @format int32 */
  thirdItemQuantity?: number;
  thirdOrderItemId?: string;
  thirdOrderItemIdRelations?: string;
  thirdPlatformType?:
    | "OTHER"
    | "BASE"
    | "SHOPIFY"
    | "STORES"
    | "AMAZON"
    | "CAFE24"
    | "OPEN"
    | "TIKTOK_SHOP"
    | "CROSSMALL";
  thirdSkuCode?: string;
  trackingNumber?: string;
  /** @format int32 */
  trackingNumberSyncStatus?: number;
}

/** ThirdShopOrderQueryResp */
export interface ThirdShopOrderQueryResp {
  allUnBindFlag?: boolean;
  /** @format int32 */
  combinedOrder?: number;
  currency?: string;
  deliveryAdditionalList?: ThirdShopOrderDeliveryAddition[];
  deliveryAdditions?: DeliveryAdditionsPojo[];
  distribution?: string;
  errorCode?: string;
  errorMessage?: string;
  /** @format int64 */
  intShipConfigId?: number;
  intShipConfigList?: IntShipConfigPojo[];
  /** @format int32 */
  isReturnLogisticsNo?: number;
  /** @format int32 */
  mutiWareHouseDelivery?: number;
  orderName?: string;
  /** @format int32 */
  orderSyncStatus?: number;
  partBindFlag?: boolean;
  /** @format int32 */
  payStatus?: number;
  /** @format int32 */
  placeOrder?: number;
  /** @format int64 */
  platformOrderId?: number;
  platformOrderList?: PlatformOrderVO[];
  platformOrderNo?: string;
  productCountries?: string[];
  /** @format int32 */
  quantity?: number;
  receiver?: ThirdShopOrderReceiver;
  /** @format int64 */
  rtsSlaTime?: number;
  /** @format int32 */
  sampleOrder?: number;
  shopOrderAmount?: number;
  /** @format int64 */
  shopOrderId?: number;
  shopOrderNo?: string;
  /** @format date-time */
  shopOrderTime?: string;
  thirdOrderStatus?: string;
  /** @format int32 */
  tiktokOrderFlag?: number;
  tiktokOrderId?: string;
}

/** ThirdShopOrderReceiver */
export interface ThirdShopOrderReceiver {
  address?: string;
  city?: string;
  clearanceCode?: string;
  country?: string;
  countryCode?: string;
  countryId?: string;
  district?: string;
  email?: string;
  name?: string;
  phone?: string;
  postalCode?: string;
  province?: string;
}

/** ThirdShopOrderSkuDTO */
export interface ThirdShopOrderSkuDTO {
  itemRemark?: string;
  thirdItemAttribute?: string;
}

/** ThirdShopOrderTimeResp */
export interface ThirdShopOrderTimeResp {
  /** @format int64 */
  shopOrderId?: number;
  /** @format date-time */
  shopOrderTime?: string;
}

/** ThirdSkuStockQueryRequest */
export interface ThirdSkuStockQueryRequest {
  /** 客样SKU列表（批量搜索） */
  itemRemarkList?: string[];
  /**
   * 未发货数最大值
   * @format int32
   */
  notDeliverMax?: number;
  /**
   * 未发货数最小值
   * @format int32
   */
  notDeliverMin?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /**
   * 处理中数最大值
   * @format int32
   */
  pendingMax?: number;
  /**
   * 处理中数最小值
   * @format int32
   */
  pendingMin?: number;
  /**
   * 绑定状态：1=已绑定，0=未绑定
   * @format int32
   */
  skuBindingStatus?: number;
  /** 商品标题（模糊搜索） */
  thirdItemName?: string;
  /**
   * 良品数最大值
   * @format int32
   */
  waitReplenishMax?: number;
  /**
   * 良品数最小值
   * @format int32
   */
  waitReplenishMin?: number;
}

/** ThirdSkuStockStatics */
export interface ThirdSkuStockStatics {
  /**
   * 异常中数量
   * @format int32
   */
  abnormalQuantity?: number;
  /** 真实返回的客样sku */
  actualItemRemark?: string;
  /**
   * SKU绑定状态：1=已绑定，0=未绑定
   * @format int32
   */
  bindStatus?: number;
  /**
   * SPU绑定类型：3=全绑定，2=部分绑定，1=未绑定
   * @format int32
   */
  bindType?: number;
  /**
   * 检品中数量
   * @format int32
   */
  checkingQuantity?: number;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /**
   * 用户店铺表id
   * @format int64
   */
  customerShopId?: number;
  /**
   * 运输中数量
   * @format int32
   */
  expressQuantity?: number;
  /**
   * 利用予定数
   * @format int32
   */
  freezeQuantity?: number;
  /**
   * 已发货数量合计
   * @format int32
   */
  hasDeliverQuantity?: number;
  /**
   * 历史已采购数量
   * @format int32
   */
  historyPurchasedQuantity?: number;
  /** @format int64 */
  isDeleted?: number;
  /** 客样sku */
  itemRemark?: string;
  /**
   * 未发货数量合计
   * @format int32
   */
  notDeliverQuantity?: number;
  /**
   * 处理中数量
   * @format int32
   */
  pendingQuantity?: number;
  /**
   * 已采购数量
   * @format int32
   */
  purchasedQuantity?: number;
  /**
   * 采购中数量
   * @format int32
   */
  purchasingQuantity?: number;
  /**
   * 已销售数量合计
   * @format int32
   */
  sellQuantity?: number;
  /**
   * 入库中数量
   * @format int32
   */
  stockInQuantity?: number;
  /** 第三方商品属性 */
  thirdItemAttribute?: string;
  /** 第三方商品编码 */
  thirdItemCode?: string;
  /** 第三方商品图片 */
  thirdItemImage?: string;
  /** 第三方商品名称 */
  thirdItemName?: string;
  /** 第三方商品状态 */
  thirdItemStatus?: string;
  /** 第三方规格编码 */
  thirdSkuCode?: string;
  /** 第三方规格图片 */
  thirdSkuImage?: string;
  /**
   * 返品不可不良品数
   * @format int32
   */
  unableDefectiveQuantity?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
  /**
   * 待采购数量
   * @format int32
   */
  waitPurchaseQuantity?: number;
  /**
   * 良品数（需补货数）
   * @format int32
   */
  waitReplenishQuantity?: number;
}

/** TiktokAuthRequest */
export interface TiktokAuthRequest {
  appKey?: string;
  code?: string;
}

/** TiktokShopWebhookRequestDTO */
export interface TiktokShopWebhookRequestDTO {
  data?: Record<string, object>;
  shop_id?: string;
  /** @format int64 */
  timestamp?: number;
  tts_notification_id?: string;
  /** @format int32 */
  type?: number;
}

/** TotalCostData */
export interface TotalCostData {
  /** @format int64 */
  customerShopId?: number;
  deliveryOrderNo?: string;
  /** @format date-time */
  deliveryTime?: string;
  detailCostData?: DetailCostData[];
  domesticShippingFee?: number;
  handlingFee?: number;
  internationalShippingFee?: number;
  productAdditionalFee?: number;
  productSettlementAmount?: number;
  shippingAdditionalFee?: number;
}

/**
 * TransportDetailInput
 * Information required to create an Amazon-partnered carrier shipping estimate, or to alert the Amazon fulfillment center to the arrival of an inbound shipment by a non-Amazon-partnered carrier.
 */
export interface TransportDetailInput {
  /** Information that you provide to Amazon about a Less Than Truckload/Full Truckload (LTL/FTL) shipment by a carrier that has not partnered with Amazon. */
  nonPartneredLtlData?: NonPartneredLtlDataInput;
  /** Information that you provide to Amazon about a Small Parcel shipment shipped by a carrier that has not partnered with Amazon. */
  nonPartneredSmallParcelData?: NonPartneredSmallParcelDataInput;
  /** Information that is required by an Amazon-partnered carrier to ship a Less Than Truckload/Full Truckload (LTL/FTL) inbound shipment. */
  partneredLtlData?: PartneredLtlDataInput;
  /** Information that is required by an Amazon-partnered carrier to ship a Small Parcel inbound shipment. */
  partneredSmallParcelData?: PartneredSmallParcelDataInput;
}

/**
 * TransportResult
 * The workflow status for a shipment with an Amazon-partnered carrier.
 */
export interface TransportResult {
  /** An error code that identifies the type of error that occured. */
  errorCode?: string;
  /** A message that describes the error condition. */
  errorDescription?: string;
  transportStatus:
    | "WORKING"
    | "ESTIMATING"
    | "ESTIMATED"
    | "ERROR_ON_ESTIMATING"
    | "CONFIRMING"
    | "CONFIRMED"
    | "ERROR_ON_CONFIRMING"
    | "VOIDING"
    | "VOIDED"
    | "ERROR_IN_VOIDING"
    | "ERROR";
}

/** UnifiedPlatformProduct */
export interface UnifiedPlatformProduct {
  combinationPlatformProduct?: CombinationPlatformProduct;
  commonPlatformProduct?: CommonPlatformProduct;
  oemPlatformProduct?: OemPlatformProduct;
  productCountry?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  purchaseCountry?: string;
}

/** UpdateAdditionReqDTO */
export interface UpdateAdditionReqDTO {
  /** @format int64 */
  customerShopId?: number;
  mappingList?: AdditionUpdatePojo[];
  newWarehouseCode?: string;
  oldWarehouseCode?: string;
}

/** UpdateGoogleStatusReqDTO */
export interface UpdateGoogleStatusReqDTO {
  ids?: number[];
}

/** UpdateInboundShipmentReq */
export interface UpdateInboundShipmentReq {
  /** @format int64 */
  customerShopId?: number;
  /** The request schema for an inbound shipment. */
  inboundShipmentRequest?: InboundShipmentRequest;
  shipmentId?: string;
}

/** UpdateInboundShipmentResp */
export interface UpdateInboundShipmentResp {
  amazonResponseBody?: AmazonResponseBody;
  shipmentId?: string;
  success?: boolean;
}

/** UpdateItemAdditionRequest */
export interface UpdateItemAdditionRequest {
  additionList?: ItemAdditionDTO[];
  /** @format int32 */
  needAdditionalFlag?: number;
  shopItemIds?: number[];
  /** 编辑的附加项所在仓库 */
  warehouseCode?: string;
}

/** UpdateItemRemarkRequest */
export interface UpdateItemRemarkRequest {
  itemRemark?: string;
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
}

/** UpdateItemSkuAdditionRequest */
export interface UpdateItemSkuAdditionRequest {
  additionList?: ItemAdditionDTO[];
  /** @format int32 */
  needAdditionalFlag?: number;
  shopItemSkuIds?: number[];
  warehouseCode?: string;
}

/** UpdateOrderItemAdditionRequest */
export interface UpdateOrderItemAdditionRequest {
  additionList?: ItemAdditionDTO[];
  /** @format int32 */
  needAdditionalFlag?: number;
  /** @format int64 */
  shopOrderItemId?: number;
  warehouseCode?: string;
}

/** UpdateShipmentBoxReq */
export interface UpdateShipmentBoxReq {
  boxInputList?: BoxInput[];
  /** @format int64 */
  customerShopId?: number;
  planNo?: string;
  shipmentId?: string;
}

/** UpdateShopOrderReceiverRequest */
export interface UpdateShopOrderReceiverRequest {
  clearanceCode?: string;
  country?: string;
  countryCode?: string;
  countryId?: string;
  shopOrderAddress?: string;
  shopOrderCity?: string;
  shopOrderCustomerName?: string;
  shopOrderDistrict?: string;
  shopOrderEmail?: string;
  /** @format int64 */
  shopOrderId?: number;
  shopOrderPostalCode?: string;
  shopOrderProvince?: string;
  shopOrderTel?: string;
}

/** UpdateSkuItemRemarkDTO */
export interface UpdateSkuItemRemarkDTO {
  /**
   * 用户店铺表id
   * @format int64
   */
  customerShopId?: number;
  /** 客样sku */
  itemRemark?: string;
  /** 三方sku编码 */
  thirdSkuCode?: string;
}

/** UploadCartonContentsFeedReq */
export interface UploadCartonContentsFeedReq {
  createXmlVO?: CreateXmlVO;
  createXmlVOs?: CreateXmlVO[];
  /** @format int64 */
  customerShopId?: number;
  planNo?: string;
}

/** UploadCartonResp */
export interface UploadCartonResp {
  /** A list of error responses returned when a request is unsuccessful. */
  errors?: ErrorList;
  feedId?: string;
  feedType?: string;
  processingStatus?: "CANCELLED" | "DONE" | "FATAL" | "IN_PROGRESS" | "IN_QUEUE";
}

/**
 * Weight
 * The weight of the package.
 */
export interface Weight {
  unit: "pounds" | "kilograms";
  /** The weight value. */
  value: number;
}

/** BizResponse«AmazonProduct» */
export interface BizResponseAmazonProduct {
  code?: string;
  data?: AmazonProduct;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ApiShopInfoResp» */
export interface BizResponseApiShopInfoResp {
  code?: string;
  data?: ApiShopInfoResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CreateInboundShipmentPlanResp» */
export interface BizResponseCreateInboundShipmentPlanResp {
  code?: string;
  data?: CreateInboundShipmentPlanResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CreateInboundShipmentResp» */
export interface BizResponseCreateInboundShipmentResp {
  code?: string;
  data?: CreateInboundShipmentResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CrossMallOrderResp» */
export interface BizResponseCrossMallOrderResp {
  code?: string;
  data?: CrossMallOrderResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerShopAuthResp» */
export interface BizResponseCustomerShopAuthResp {
  code?: string;
  data?: CustomerShopAuthResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«FundUtilizationDetailsData» */
export interface BizResponseFundUtilizationDetailsData {
  code?: string;
  /** 资金使用明细数据 */
  data?: FundUtilizationDetailsData;
  msg?: string;
  success?: boolean;
}

/** BizResponse«GetLabelResp» */
export interface BizResponseGetLabelResp {
  code?: string;
  data?: GetLabelResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«GetUploadStatusResp» */
export interface BizResponseGetUploadStatusResp {
  code?: string;
  data?: GetUploadStatusResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«LastUpdateTimeResult» */
export interface BizResponseLastUpdateTimeResult {
  code?: string;
  data?: LastUpdateTimeResult;
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«AmazonProductResp»» */
export interface BizResponseListAmazonProductResp {
  code?: string;
  data?: AmazonProductResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«AmazonProduct»» */
export interface BizResponseListAmazonProduct {
  code?: string;
  data?: AmazonProduct[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ApiShopInfoResp»» */
export interface BizResponseListApiShopInfoResp {
  code?: string;
  data?: ApiShopInfoResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CrossMallProductResp»» */
export interface BizResponseListCrossMallProductResp {
  code?: string;
  data?: CrossMallProductResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CrossMallProduct»» */
export interface BizResponseListCrossMallProduct {
  code?: string;
  data?: CrossMallProduct[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerProductDataPageDTO»» */
export interface BizResponseListCustomerProductDataPageDTO {
  code?: string;
  data?: CustomerProductDataPageDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerShopAuthResp»» */
export interface BizResponseListCustomerShopAuthResp {
  code?: string;
  data?: CustomerShopAuthResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«FbaShipmentBoxesRespDTO»» */
export interface BizResponseListFbaShipmentBoxesRespDTO {
  code?: string;
  data?: FbaShipmentBoxesRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ItemSkuMappingResp»» */
export interface BizResponseListItemSkuMappingResp {
  code?: string;
  data?: ItemSkuMappingResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ManualCreateOrderResult»» */
export interface BizResponseListManualCreateOrderResult {
  code?: string;
  data?: ManualCreateOrderResult[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«OpenOrderRespDTO»» */
export interface BizResponseListOpenOrderRespDTO {
  code?: string;
  data?: OpenOrderRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«OperationLogResp»» */
export interface BizResponseListOperationLogResp {
  code?: string;
  data?: OperationLogResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«PlatformLogisticsResp»» */
export interface BizResponseListPlatformLogisticsResp {
  code?: string;
  data?: PlatformLogisticsResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«PrepCategoryClass»» */
export interface BizResponseListPrepCategoryClass {
  code?: string;
  data?: PrepCategoryClass[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«QueryBindGoodsRespDTO»» */
export interface BizResponseListQueryBindGoodsRespDTO {
  code?: string;
  data?: QueryBindGoodsRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ReplenishPlanResp»» */
export interface BizResponseListReplenishPlanResp {
  code?: string;
  data?: ReplenishPlanResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SelectShopOrderItemsResp»» */
export interface BizResponseListSelectShopOrderItemsResp {
  code?: string;
  data?: SelectShopOrderItemsResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«TTSCategoryResp»» */
export interface BizResponseListTTSCategoryResp {
  code?: string;
  data?: TTSCategoryResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ThirdShopItemSkuResp»» */
export interface BizResponseListThirdShopItemSkuResp {
  code?: string;
  data?: ThirdShopItemSkuResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ThirdShopItem»» */
export interface BizResponseListThirdShopItem {
  code?: string;
  data?: ThirdShopItem[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ThirdShopOrderTimeResp»» */
export interface BizResponseListThirdShopOrderTimeResp {
  code?: string;
  data?: ThirdShopOrderTimeResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ThirdShopOrder»» */
export interface BizResponseListThirdShopOrder {
  code?: string;
  data?: ThirdShopOrder[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«long»» */
export interface BizResponseListLong {
  code?: string;
  data?: number[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«string»» */
export interface BizResponseListString {
  code?: string;
  data?: string[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«OrderSkuFeeNumberDetailsRespDTO» */
export interface BizResponseOrderSkuFeeNumberDetailsRespDTO {
  code?: string;
  /** 订单商品行费用及数量明细 */
  data?: OrderSkuFeeNumberDetailsRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«OrderSkuStockFeeDetailsRespDTO» */
export interface BizResponseOrderSkuStockFeeDetailsRespDTO {
  code?: string;
  /** 直发订单商品行囤货单费用明细 */
  data?: OrderSkuStockFeeDetailsRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«AmazonProduct»» */
export interface BizResponsePageResultAmazonProduct {
  code?: string;
  data?: PageResultAmazonProduct;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«CrossMallOrderResp»» */
export interface BizResponsePageResultCrossMallOrderResp {
  code?: string;
  data?: PageResultCrossMallOrderResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«CrossMallProduct»» */
export interface BizResponsePageResultCrossMallProduct {
  code?: string;
  data?: PageResultCrossMallProduct;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«CustomerProductDataPageDTO»» */
export interface BizResponsePageResultCustomerProductDataPageDTO {
  code?: string;
  data?: PageResultCustomerProductDataPageDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«OnTheWayStockQueryResoDTO»» */
export interface BizResponsePageResultOnTheWayStockQueryResoDTO {
  code?: string;
  data?: PageResultOnTheWayStockQueryResoDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ReplenishPlanResp»» */
export interface BizResponsePageResultReplenishPlanResp {
  code?: string;
  data?: PageResultReplenishPlanResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ThirdShopItemResp»» */
export interface BizResponsePageResultThirdShopItemResp {
  code?: string;
  data?: PageResultThirdShopItemResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ThirdShopOrderQueryResp»» */
export interface BizResponsePageResultThirdShopOrderQueryResp {
  code?: string;
  data?: PageResultThirdShopOrderQueryResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ThirdSkuStockStatics»» */
export interface BizResponsePageResultThirdSkuStockStatics {
  code?: string;
  data?: PageResultThirdSkuStockStatics;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PlatformLogisticsResp» */
export interface BizResponsePlatformLogisticsResp {
  code?: string;
  data?: PlatformLogisticsResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PutTransportDetailsResp» */
export interface BizResponsePutTransportDetailsResp {
  code?: string;
  data?: PutTransportDetailsResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«QueryOrderCountRespDTO» */
export interface BizResponseQueryOrderCountRespDTO {
  code?: string;
  data?: QueryOrderCountRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ReplenishPlanResp» */
export interface BizResponseReplenishPlanResp {
  code?: string;
  data?: ReplenishPlanResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«TaskResp» */
export interface BizResponseTaskResp {
  code?: string;
  data?: TaskResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopAuthBindCheckResp» */
export interface BizResponseThirdShopAuthBindCheckResp {
  code?: string;
  data?: ThirdShopAuthBindCheckResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopAuthBindResp» */
export interface BizResponseThirdShopAuthBindResp {
  code?: string;
  data?: ThirdShopAuthBindResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopItemMappingResp» */
export interface BizResponseThirdShopItemMappingResp {
  code?: string;
  data?: ThirdShopItemMappingResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopItemResp» */
export interface BizResponseThirdShopItemResp {
  code?: string;
  data?: ThirdShopItemResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopItemSkuResp» */
export interface BizResponseThirdShopItemSkuResp {
  code?: string;
  data?: ThirdShopItemSkuResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopOrderSkuDTO» */
export interface BizResponseThirdShopOrderSkuDTO {
  code?: string;
  data?: ThirdShopOrderSkuDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«UpdateInboundShipmentResp» */
export interface BizResponseUpdateInboundShipmentResp {
  code?: string;
  data?: UpdateInboundShipmentResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«UploadCartonResp» */
export interface BizResponseUploadCartonResp {
  code?: string;
  data?: UploadCartonResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Void» */
export interface BizResponseVoid {
  code?: string;
  msg?: string;
  success?: boolean;
}

/** BizResponse«boolean» */
export interface BizResponseBoolean {
  code?: string;
  data?: boolean;
  msg?: string;
  success?: boolean;
}

/** BizResponse«int» */
export interface BizResponseInt {
  code?: string;
  /** @format int32 */
  data?: number;
  msg?: string;
  success?: boolean;
}

/** BizResponse«long» */
export interface BizResponseLong {
  code?: string;
  /** @format int64 */
  data?: number;
  msg?: string;
  success?: boolean;
}

/** BizResponse«object» */
export interface BizResponseObject {
  code?: string;
  data?: object;
  msg?: string;
  success?: boolean;
}

/** BizResponse«string» */
export interface BizResponseString {
  code?: string;
  data?: string;
  msg?: string;
  success?: boolean;
}

/** PageResult«AmazonProduct» */
export interface PageResultAmazonProduct {
  /** @format int64 */
  current?: number;
  records?: AmazonProduct[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«CrossMallOrderResp» */
export interface PageResultCrossMallOrderResp {
  /** @format int64 */
  current?: number;
  records?: CrossMallOrderResp[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«CrossMallProduct» */
export interface PageResultCrossMallProduct {
  /** @format int64 */
  current?: number;
  records?: CrossMallProduct[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«CustomerProductDataPageDTO» */
export interface PageResultCustomerProductDataPageDTO {
  /** @format int64 */
  current?: number;
  records?: CustomerProductDataPageDTO[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«OnTheWayStockQueryResoDTO» */
export interface PageResultOnTheWayStockQueryResoDTO {
  /** @format int64 */
  current?: number;
  records?: OnTheWayStockQueryResoDTO[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«ReplenishPlanResp» */
export interface PageResultReplenishPlanResp {
  /** @format int64 */
  current?: number;
  records?: ReplenishPlanResp[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«ThirdShopItemResp» */
export interface PageResultThirdShopItemResp {
  /** @format int64 */
  current?: number;
  records?: ThirdShopItemResp[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«ThirdShopOrderQueryResp» */
export interface PageResultThirdShopOrderQueryResp {
  /** @format int64 */
  current?: number;
  records?: ThirdShopOrderQueryResp[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«ThirdSkuStockStatics» */
export interface PageResultThirdSkuStockStatics {
  /** @format int64 */
  current?: number;
  records?: ThirdSkuStockStatics[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

import axios, { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "//master-gateway.theckb.com:443/api",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title API文档
 * @version v1.0.0
 * @baseUrl //master-gateway.theckb.com:443/api
 * @contact 史尼芙 (https://www.taobaockb.com/)
 *
 * 史尼芙API文档
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  probe = {
    /**
     * No description
     *
     * @tags livens-probe-controller
     * @name Test
     * @summary 执行一次健康检查探针
     * @request GET:/Probe/test
     */
    test: (params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/Probe/test`,
        method: "GET",
        ...params,
      }),
  };
  actuator1 = {
    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo
     * @summary jvmInfo
     * @request GET:/actuator1/jvmInfo
     */
    jvmInfo: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name HeadActuator1
     * @summary jvmInfo
     * @request HEAD:/actuator1/jvmInfo
     */
    headActuator1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "HEAD",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo2
     * @summary jvmInfo
     * @request POST:/actuator1/jvmInfo
     * @originalName jvmInfo
     * @duplicate
     */
    jvmInfo2: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo3
     * @summary jvmInfo
     * @request PUT:/actuator1/jvmInfo
     * @originalName jvmInfo
     * @duplicate
     */
    jvmInfo3: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "PUT",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo4
     * @summary jvmInfo
     * @request DELETE:/actuator1/jvmInfo
     * @originalName jvmInfo
     * @duplicate
     */
    jvmInfo4: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name OptionsActuator1
     * @summary jvmInfo
     * @request OPTIONS:/actuator1/jvmInfo
     */
    optionsActuator1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "OPTIONS",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo5
     * @summary jvmInfo
     * @request PATCH:/actuator1/jvmInfo
     * @originalName jvmInfo
     * @duplicate
     */
    jvmInfo5: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "PATCH",
        type: ContentType.Json,
        ...params,
      }),
  };
  addition = {
    /**
     * No description
     *
     * @tags api-addition-client-impl
     * @name UpdateAllConfigId
     * @summary updateAllConfigId
     * @request POST:/addition/updateAllConfigId
     */
    updateAllConfigId: (reqDTO: UpdateAdditionReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/addition/updateAllConfigId`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  amazon = {
    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductGetAmazonProductByMsku
     * @summary getAmazonProductByMsku
     * @request POST:/amazon/product/getAmazonProductByMsku
     */
    productGetAmazonProductByMsku: (req: GetAmazonProductByMskuRequest, params: RequestParams = {}) =>
      this.request<BizResponseListAmazonProduct, any>({
        path: `/amazon/product/getAmazonProductByMsku`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductList
     * @summary listAmazonProductEnum
     * @request POST:/amazon/product/list
     */
    productList: (params: RequestParams = {}) =>
      this.request<BizResponseListPrepCategoryClass, any>({
        path: `/amazon/product/list`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductPage
     * @summary pageAmazonProduct
     * @request POST:/amazon/product/page
     */
    productPage: (req: QueryAmazonProductRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultAmazonProduct, any>({
        path: `/amazon/product/page`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductRemove
     * @summary remove
     * @request POST:/amazon/product/remove
     */
    productRemove: (req: RemoveAmazonProductRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/amazon/product/remove`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductSync
     * @summary sync
     * @request POST:/amazon/product/sync
     */
    productSync: (req: SyncAmazonProductRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/amazon/product/sync`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductSyncItem
     * @summary syncItem
     * @request POST:/amazon/product/syncItem
     */
    productSyncItem: (req: RemoveAmazonProductRequest, params: RequestParams = {}) =>
      this.request<BizResponseAmazonProduct, any>({
        path: `/amazon/product/syncItem`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  amazonProduct = {
    /**
     * No description
     *
     * @tags amazon-product-sku-client-impl
     * @name QueryProducts
     * @summary queryProducts
     * @request POST:/amazonProduct/queryProducts
     */
    queryProducts: (req: QueryAmazonProductReq, params: RequestParams = {}) =>
      this.request<BizResponseListAmazonProductResp, any>({
        path: `/amazonProduct/queryProducts`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  cafe24 = {
    /**
     * No description
     *
     * @tags cafe-24-app-controller
     * @name AuthCafe24
     * @summary authCafe24
     * @request POST:/cafe24/authCafe24
     */
    authCafe24: (request: Cafe24AuthRequest, params: RequestParams = {}) =>
      this.request<BizResponseLong, any>({
        path: `/cafe24/authCafe24`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cafe-24-app-controller
     * @name InstallApp
     * @summary installApp
     * @request GET:/cafe24/installApp
     */
    installApp: (
      query: {
        /** code */
        code: string;
        /** state */
        state: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/cafe24/installApp`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cafe-24-app-controller
     * @name InstallAppRequest
     * @summary installAppRequest
     * @request GET:/cafe24/installAppRequest
     */
    installAppRequest: (
      query: {
        /** mall_id */
        mall_id: string;
        /**
         * shop_no
         * @format int32
         */
        shop_no: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/cafe24/installAppRequest`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  crossBorder = {
    /**
     * No description
     *
     * @tags item
     * @name ItemAdd
     * @summary create product
     * @request POST:/crossBorder/item/add
     */
    itemAdd: (addOpenItemReqDTO: AddOpenItemReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/crossBorder/item/add`,
        method: "POST",
        body: addOpenItemReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags order
     * @name OrderCreate
     * @summary create order
     * @request POST:/crossBorder/order/create
     */
    orderCreate: (createOrderReqDTO: CreateOrderReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/crossBorder/order/create`,
        method: "POST",
        body: createOrderReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags order
     * @name OrderGet
     * @summary get order
     * @request POST:/crossBorder/order/get
     */
    orderGet: (getOrderReqDTO: GetOrderReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseListOpenOrderRespDTO, any>({
        path: `/crossBorder/order/get`,
        method: "POST",
        body: getOrderReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  crossMall = {
    /**
     * No description
     *
     * @tags cross-mall-product-sku-controller
     * @name ProductGetCrossMallProductBySku
     * @summary getCrossMallProductBySku
     * @request POST:/crossMall/product/getCrossMallProductBySku
     */
    productGetCrossMallProductBySku: (req: GetCrossMallProductRequest, params: RequestParams = {}) =>
      this.request<BizResponseListCrossMallProduct, any>({
        path: `/crossMall/product/getCrossMallProductBySku`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-product-sku-controller
     * @name ProductPage
     * @summary page
     * @request POST:/crossMall/product/page
     */
    productPage: (req: QueryCrossMallProductRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultCrossMallProduct, any>({
        path: `/crossMall/product/page`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-product-sku-controller
     * @name ProductRemove
     * @summary remove
     * @request POST:/crossMall/product/remove
     */
    productRemove: (req: RemoveCrossMallProductRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/crossMall/product/remove`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-product-sku-controller
     * @name ProductSync
     * @summary sync
     * @request POST:/crossMall/product/sync
     */
    productSync: (req: SyncCrossMallProductRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/crossMall/product/sync`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-product-sku-controller
     * @name ProductSyncItem
     * @summary syncItem
     * @request POST:/crossMall/product/syncItem
     */
    productSyncItem: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/crossMall/product/syncItem`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  crossMallProduct = {
    /**
     * No description
     *
     * @tags cross-mall-product-sku-client-impl
     * @name BatchSaveOrUpdate
     * @summary batchSaveOrUpdate
     * @request POST:/crossMallProduct/batchSaveOrUpdate
     */
    batchSaveOrUpdate: (req: CustomerProductDataPageDTO[], params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/crossMallProduct/batchSaveOrUpdate`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-product-sku-client-impl
     * @name ListProduct
     * @summary listProduct
     * @request POST:/crossMallProduct/listProduct
     */
    listProduct: (req: QueryCrossMallProductReq, params: RequestParams = {}) =>
      this.request<BizResponseListCustomerProductDataPageDTO, any>({
        path: `/crossMallProduct/listProduct`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-product-sku-client-impl
     * @name PageQuery
     * @summary pageQuery
     * @request POST:/crossMallProduct/pageQuery
     */
    pageQuery: (req: CustomerProductDataPageRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultCustomerProductDataPageDTO, any>({
        path: `/crossMallProduct/pageQuery`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-product-sku-client-impl
     * @name QueryProducts
     * @summary queryProducts
     * @request POST:/crossMallProduct/queryProducts
     */
    queryProducts: (req: QueryCrossMallProductReq, params: RequestParams = {}) =>
      this.request<BizResponseListCrossMallProductResp, any>({
        path: `/crossMallProduct/queryProducts`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  crossmall = {
    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderBatchDelete
     * @summary 批量删除
     * @request POST:/crossmall/order/batchDelete
     */
    orderBatchDelete: (request: CrossMallOrderDeleteRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/crossmall/order/batchDelete`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderCreateDeliveryOrders
     * @summary 一键下单（单个/批量）
     * @request POST:/crossmall/order/createDeliveryOrders
     */
    orderCreateDeliveryOrders: (req: CreateCrossMallDeliveryOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/crossmall/order/createDeliveryOrders`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderDetail
     * @summary 订单详情
     * @request GET:/crossmall/order/detail
     */
    orderDetail: (
      query: {
        /**
         * orderId
         * @format int64
         */
        orderId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCrossMallOrderResp, any>({
        path: `/crossmall/order/detail`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderEditAddress
     * @summary 编辑地址
     * @request POST:/crossmall/order/editAddress
     */
    orderEditAddress: (request: CrossMallOrderAddressEditRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/crossmall/order/editAddress`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderEditShip
     * @summary 编辑物流
     * @request POST:/crossmall/order/editShip
     */
    orderEditShip: (request: CrossMallOrderShipEditRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/crossmall/order/editShip`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderExport
     * @summary 订单导出
     * @request POST:/crossmall/order/export
     */
    orderExport: (request: CrossMallOrderQueryRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/crossmall/order/export`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderIntercept
     * @summary 订单拦截/取消
     * @request POST:/crossmall/order/intercept
     */
    orderIntercept: (request: CrossMallOrderInterceptRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/crossmall/order/intercept`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderLog
     * @summary 操作日志
     * @request GET:/crossmall/order/log
     */
    orderLog: (
      query: {
        /**
         * orderId
         * @format int64
         */
        orderId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListOperationLogResp, any>({
        path: `/crossmall/order/log`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderPage
     * @summary 订单列表
     * @request POST:/crossmall/order/page
     */
    orderPage: (request: CrossMallOrderQueryRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultCrossMallOrderResp, any>({
        path: `/crossmall/order/page`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cross-mall-order-controller
     * @name OrderPullOrder
     * @summary 同步订单
     * @request POST:/crossmall/order/pullOrder
     */
    orderPullOrder: (req: PullCrossMallOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/crossmall/order/pullOrder`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  getTaskResult = {
    /**
     * No description
     *
     * @tags task-controller
     * @name GetTaskResult
     * @summary getTask
     * @request GET:/getTaskResult
     */
    getTaskResult: (
      query: {
        /** taskId */
        taskId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseTaskResp, any>({
        path: `/getTaskResult`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  inbound = {
    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name CancelInboundShipment
     * @summary cancelInboundShipment
     * @request GET:/inbound/cancelInboundShipment
     */
    cancelInboundShipment: (
      query: {
        /** planNo */
        planNo: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/inbound/cancelInboundShipment`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name CreateShipment
     * @summary createInboundShipment
     * @request POST:/inbound/create/shipment
     */
    createShipment: (request: CreateInboundShipmentReq, params: RequestParams = {}) =>
      this.request<BizResponseCreateInboundShipmentResp, any>({
        path: `/inbound/create/shipment`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name CreateShipmentPlan
     * @summary createInboundShipmentPlan
     * @request POST:/inbound/create/shipment/plan
     */
    createShipmentPlan: (request: CreateInboundShipmentPlanReq, params: RequestParams = {}) =>
      this.request<BizResponseCreateInboundShipmentPlanResp, any>({
        path: `/inbound/create/shipment/plan`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name GetLabel
     * @summary getLabel
     * @request POST:/inbound/get/label
     */
    getLabel: (request: GetLabelReq, params: RequestParams = {}) =>
      this.request<BizResponseGetLabelResp, any>({
        path: `/inbound/get/label`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name ListShipmentBoxs
     * @summary listShipmentBoxes
     * @request POST:/inbound/list/shipment/boxs
     */
    listShipmentBoxs: (req: ListShipmentBoxesReq, params: RequestParams = {}) =>
      this.request<BizResponseListFbaShipmentBoxesRespDTO, any>({
        path: `/inbound/list/shipment/boxs`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name PutTransportDetails
     * @summary putTransportDetails
     * @request POST:/inbound/put/transport/details
     */
    putTransportDetails: (request: PutTransportDetailsReq, params: RequestParams = {}) =>
      this.request<BizResponsePutTransportDetailsResp, any>({
        path: `/inbound/put/transport/details`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UpdateShipment
     * @summary updateInboundShipment
     * @request POST:/inbound/update/shipment
     */
    updateShipment: (request: UpdateInboundShipmentReq, params: RequestParams = {}) =>
      this.request<BizResponseUpdateInboundShipmentResp, any>({
        path: `/inbound/update/shipment`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UpdateShipmentBox
     * @summary updateShipmentBox
     * @request POST:/inbound/update/shipment/box
     */
    updateShipmentBox: (req: UpdateShipmentBoxReq, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/inbound/update/shipment/box`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UploadCartonContents
     * @summary uploadCartonContents
     * @request POST:/inbound/upload/carton/contents
     */
    uploadCartonContents: (request: UploadCartonContentsFeedReq, params: RequestParams = {}) =>
      this.request<BizResponseUploadCartonResp, any>({
        path: `/inbound/upload/carton/contents`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UploadCartonSizeInfo
     * @summary uploadCartonSizeInfo
     * @request POST:/inbound/upload/carton/size/info
     */
    uploadCartonSizeInfo: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
        /** shipmentId */
        shipmentId?: string;
      },
      data: {
        /** file */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseUploadCartonResp, any>({
        path: `/inbound/upload/carton/size/info`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UploadStatus
     * @summary getUploadStatus
     * @request POST:/inbound/upload/status
     */
    uploadStatus: (request: GetUploadStatusReq, params: RequestParams = {}) =>
      this.request<BizResponseGetUploadStatusResp, any>({
        path: `/inbound/upload/status`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),
  };
  logisticsPlatform = {
    /**
     * No description
     *
     * @tags logistics-platform-client-impl
     * @name GetByIds
     * @summary getByIds
     * @request GET:/logisticsPlatform/getByIds
     */
    getByIds: (
      query: {
        /** logisticsIdList */
        logisticsIdList: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListPlatformLogisticsResp, any>({
        path: `/logisticsPlatform/getByIds`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags logistics-platform-client-impl
     * @name GetByPlatformType
     * @summary getByPlatformType
     * @request GET:/logisticsPlatform/getByPlatformType
     */
    getByPlatformType: (
      query?: {
        /**
         * platformType
         * @format int32
         */
        platformType?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListPlatformLogisticsResp, any>({
        path: `/logisticsPlatform/getByPlatformType`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags logistics-platform-client-impl
     * @name GetByPlatformTypeAndName
     * @summary getByPlatformTypeAndName
     * @request GET:/logisticsPlatform/getByPlatformTypeAndName
     */
    getByPlatformTypeAndName: (
      query: {
        /** name */
        name: string;
        /**
         * platformType
         * @format int32
         */
        platformType: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePlatformLogisticsResp, any>({
        path: `/logisticsPlatform/getByPlatformTypeAndName`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  manage = {
    /**
     * No description
     *
     * @tags 补货计划(后台)
     * @name ReplenishPlanPage
     * @summary 补货计划分页
     * @request GET:/manage/replenishPlan/page
     */
    replenishPlanPage: (
      query?: {
        amazonMsku?: string;
        amazonMskuList?: string[];
        /** @format int64 */
        customerId?: number;
        customerName?: string;
        /** @format int64 */
        customerShopId?: number;
        customerShopName?: string;
        keywordName?: string;
        /** @format int32 */
        pageNum?: number;
        /** @format int32 */
        pageSize?: number;
        /** @format int32 */
        planStatus?: number;
        productSku?: string;
        productSkuList?: string[];
        shipmentId?: string;
        shipmentIdList?: string[];
        unificationCustomerFullName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageResultReplenishPlanResp, any>({
        path: `/manage/replenishPlan/page`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  ops = {
    /**
     * No description
     *
     * @tags ops-amazon-controller
     * @name AmazonSearchProducts
     * @summary searchProducts
     * @request POST:/ops/amazon/searchProducts
     */
    amazonSearchProducts: (req: SearchProductsReq, params: RequestParams = {}) =>
      this.request<BizResponseListAmazonProduct, any>({
        path: `/ops/amazon/searchProducts`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ops-base-controller
     * @name BaseSearchOrders
     * @summary searchOrders
     * @request POST:/ops/base/searchOrders
     */
    baseSearchOrders: (req: SearchOrdersReq, params: RequestParams = {}) =>
      this.request<BizResponseListThirdShopOrder, any>({
        path: `/ops/base/searchOrders`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ops-base-controller
     * @name BaseSearchProducts
     * @summary searchProducts
     * @request POST:/ops/base/searchProducts
     */
    baseSearchProducts: (req: SearchProductsReq, params: RequestParams = {}) =>
      this.request<BizResponseListThirdShopItem, any>({
        path: `/ops/base/searchProducts`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ops-shopify-controller
     * @name ShopifySearchOrders
     * @summary searchOrders
     * @request POST:/ops/shopify/searchOrders
     */
    shopifySearchOrders: (req: SearchOrdersReq, params: RequestParams = {}) =>
      this.request<BizResponseListThirdShopOrder, any>({
        path: `/ops/shopify/searchOrders`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ops-shopify-controller
     * @name ShopifySearchProducts
     * @summary searchProducts
     * @request POST:/ops/shopify/searchProducts
     */
    shopifySearchProducts: (req: SearchProductsReq, params: RequestParams = {}) =>
      this.request<BizResponseListThirdShopItem, any>({
        path: `/ops/shopify/searchProducts`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  orderProcess = {
    /**
     * No description
     *
     * @tags 测试管理
     * @name TestBaseRefresh
     * @summary baseRefresh
     * @request POST:/orderProcess/test/baseRefresh
     */
    testBaseRefresh: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/orderProcess/test/baseRefresh`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 测试管理
     * @name TestTestCreateOrder
     * @summary testCreateOrder
     * @request POST:/orderProcess/test/testCreateOrder
     */
    testTestCreateOrder: (orderIdList: number[], params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/orderProcess/test/testCreateOrder`,
        method: "POST",
        body: orderIdList,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 测试管理
     * @name TestTestOrderProcess
     * @summary testOrderProcess
     * @request POST:/orderProcess/test/testOrderProcess
     */
    testTestOrderProcess: (testOrderProcessReq: TestOrderProcessReq, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/orderProcess/test/testOrderProcess`,
        method: "POST",
        body: testOrderProcessReq,
        type: ContentType.Json,
        ...params,
      }),
  };
  replenishPlan = {
    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name CancelPlan
     * @summary cancelPlan
     * @request POST:/replenishPlan/cancelPlan
     */
    cancelPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/cancelPlan`,
        method: "POST",
        body: shipmentId,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name CheckDiscardPlan
     * @summary checkDiscardPlan
     * @request GET:/replenishPlan/check/discardPlan
     */
    checkDiscardPlan: (
      query: {
        /** shipmentId */
        shipmentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListString, any>({
        path: `/replenishPlan/check/discardPlan`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name CheckSku
     * @summary checkSku
     * @request GET:/replenishPlan/checkSku
     */
    checkSku: (
      query: {
        /** msku */
        msku: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseInt, any>({
        path: `/replenishPlan/checkSku`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan
     * @summary confirmPlan
     * @request GET:/replenishPlan/confirmPlan/{shipmentId}
     */
    confirmPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name HeadReplenishPlan
     * @summary confirmPlan
     * @request HEAD:/replenishPlan/confirmPlan/{shipmentId}
     */
    headReplenishPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "HEAD",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan2
     * @summary confirmPlan
     * @request POST:/replenishPlan/confirmPlan/{shipmentId}
     * @originalName confirmPlan
     * @duplicate
     */
    confirmPlan2: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan3
     * @summary confirmPlan
     * @request PUT:/replenishPlan/confirmPlan/{shipmentId}
     * @originalName confirmPlan
     * @duplicate
     */
    confirmPlan3: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "PUT",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan4
     * @summary confirmPlan
     * @request DELETE:/replenishPlan/confirmPlan/{shipmentId}
     * @originalName confirmPlan
     * @duplicate
     */
    confirmPlan4: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name OptionsReplenishPlan
     * @summary confirmPlan
     * @request OPTIONS:/replenishPlan/confirmPlan/{shipmentId}
     */
    optionsReplenishPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "OPTIONS",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan5
     * @summary confirmPlan
     * @request PATCH:/replenishPlan/confirmPlan/{shipmentId}
     * @originalName confirmPlan
     * @duplicate
     */
    confirmPlan5: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "PATCH",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name CreatePlan
     * @summary createPlan
     * @request POST:/replenishPlan/createPlan
     */
    createPlan: (reqDTO: CreateReplenishPlanReq, params: RequestParams = {}) =>
      this.request<BizResponseCreateInboundShipmentPlanResp, any>({
        path: `/replenishPlan/createPlan`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name DiscardPlan
     * @summary discardPlan
     * @request POST:/replenishPlan/discardPlan/{shipmentId}
     */
    discardPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/discardPlan/${shipmentId}`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name GetProcessingReplenishPlanList
     * @summary getProcessingReplenishPlanList
     * @request POST:/replenishPlan/getProcessingReplenishPlanList
     */
    getProcessingReplenishPlanList: (amazonMsku: string, params: RequestParams = {}) =>
      this.request<BizResponseListReplenishPlanResp, any>({
        path: `/replenishPlan/getProcessingReplenishPlanList`,
        method: "POST",
        body: amazonMsku,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name GetReplenishPlan
     * @summary getReplenishPlan
     * @request POST:/replenishPlan/getReplenishPlan
     */
    getReplenishPlan: (
      query: {
        /** shipmentId */
        shipmentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseReplenishPlanResp, any>({
        path: `/replenishPlan/getReplenishPlan`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name NotifyDelivered
     * @summary notifyDelivered
     * @request POST:/replenishPlan/notifyDelivered
     */
    notifyDelivered: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/notifyDelivered`,
        method: "POST",
        body: shipmentId,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name Page
     * @summary page
     * @request POST:/replenishPlan/page
     */
    page: (reqDTO: CustomerReplenishPlanReq, params: RequestParams = {}) =>
      this.request<BizResponsePageResultReplenishPlanResp, any>({
        path: `/replenishPlan/page`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name SelectReplenishPlanList
     * @summary selectReplenishPlanList
     * @request POST:/replenishPlan/selectReplenishPlanList
     */
    selectReplenishPlanList: (req: ReplenishPlanListReq, params: RequestParams = {}) =>
      this.request<BizResponseListReplenishPlanResp, any>({
        path: `/replenishPlan/selectReplenishPlanList`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name SetPreps
     * @summary setPreps
     * @request POST:/replenishPlan/setPreps
     */
    setPreps: (request: GetAmazonProductByMskuRequest, params: RequestParams = {}) =>
      this.request<BizResponseString, any>({
        path: `/replenishPlan/setPreps`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),
  };
  shop = {
    /**
     * No description
     *
     * @tags api-shop-client-impl
     * @name GetAuth
     * @summary getCustomerShopAuth
     * @request GET:/shop/getAuth
     */
    getAuth: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerShopAuthResp, any>({
        path: `/shop/getAuth`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-shop-client-impl
     * @name GetAuthList
     * @summary getAuthList
     * @request GET:/shop/getAuthList
     */
    getAuthList: (
      query: {
        /** customerShopIdSet */
        customerShopIdSet: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopAuthResp, any>({
        path: `/shop/getAuthList`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-shop-client-impl
     * @name GetCustomerAuthStatus
     * @summary getBaseCustomerAuthStatus
     * @request GET:/shop/getCustomerAuthStatus
     */
    getCustomerAuthStatus: (
      query: {
        /** customerShopIdSet */
        customerShopIdSet: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopAuthResp, any>({
        path: `/shop/getCustomerAuthStatus`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-shop-client-impl
     * @name ShopStat
     * @summary shopStat
     * @request GET:/shop/shopStat
     */
    shopStat: (
      query: {
        /** customerShopIdSet */
        customerShopIdSet: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListApiShopInfoResp, any>({
        path: `/shop/shopStat`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-shop-client-impl
     * @name SingleShopStat
     * @summary singleShopStat
     * @request GET:/shop/singleShopStat
     */
    singleShopStat: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseApiShopInfoResp, any>({
        path: `/shop/singleShopStat`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  test = {
    /**
     * No description
     *
     * @tags test-controller
     * @name GetNacosData
     * @summary 获取nacos配置数据
     * @request GET:/test/get/nacos/data
     */
    getNacosData: (params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/test/get/nacos/data`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name GetNacosData1
     * @summary 获取nacos配置数据
     * @request GET:/test/get/nacos/data1
     */
    getNacosData1: (params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/test/get/nacos/data1`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping
     * @summary ping
     * @request GET:/test/ping
     */
    ping: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name HeadTest
     * @summary ping
     * @request HEAD:/test/ping
     */
    headTest: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "HEAD",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping2
     * @summary ping
     * @request POST:/test/ping
     * @originalName ping
     * @duplicate
     */
    ping2: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping3
     * @summary ping
     * @request PUT:/test/ping
     * @originalName ping
     * @duplicate
     */
    ping3: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "PUT",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping4
     * @summary ping
     * @request DELETE:/test/ping
     * @originalName ping
     * @duplicate
     */
    ping4: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name OptionsTest
     * @summary ping
     * @request OPTIONS:/test/ping
     */
    optionsTest: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "OPTIONS",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping5
     * @summary ping
     * @request PATCH:/test/ping
     * @originalName ping
     * @duplicate
     */
    ping5: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "PATCH",
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdShopAuth = {
    /**
     * No description
     *
     * @tags 店铺管理
     * @name Bind
     * @summary 店铺绑定
     * @request POST:/thirdShopAuth/bind
     */
    bind: (req: ThirdShopAuthBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/bind`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name BindCheck
     * @summary 店铺绑定确认
     * @request POST:/thirdShopAuth/bindCheck
     */
    bindCheck: (req: ThirdShopAuthBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseThirdShopAuthBindCheckResp, any>({
        path: `/thirdShopAuth/bindCheck`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name IsBind
     * @summary 店铺是否绑定过
     * @request GET:/thirdShopAuth/isBind
     */
    isBind: (params: RequestParams = {}) =>
      this.request<BizResponseThirdShopAuthBindResp, any>({
        path: `/thirdShopAuth/isBind`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind
     * @summary 店铺解绑
     * @request GET:/thirdShopAuth/unBind
     */
    unBind: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name HeadThirdShopAuth
     * @summary 店铺解绑
     * @request HEAD:/thirdShopAuth/unBind
     */
    headThirdShopAuth: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind2
     * @summary 店铺解绑
     * @request POST:/thirdShopAuth/unBind
     * @originalName unBind
     * @duplicate
     */
    unBind2: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind3
     * @summary 店铺解绑
     * @request PUT:/thirdShopAuth/unBind
     * @originalName unBind
     * @duplicate
     */
    unBind3: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind4
     * @summary 店铺解绑
     * @request DELETE:/thirdShopAuth/unBind
     * @originalName unBind
     * @duplicate
     */
    unBind4: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name OptionsThirdShopAuth
     * @summary 店铺解绑
     * @request OPTIONS:/thirdShopAuth/unBind
     */
    optionsThirdShopAuth: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind5
     * @summary 店铺解绑
     * @request PATCH:/thirdShopAuth/unBind
     * @originalName unBind
     * @duplicate
     */
    unBind5: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdShopItem = {
    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name AddJpSpu
     * @summary 添加商品
     * @request PUT:/thirdShopItem/addJPSpu
     */
    addJpSpu: (
      query: {
        /**
         * shopItemId
         * @format int64
         */
        shopItemId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopItem/addJPSpu`,
        method: "PUT",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name BatchDelete
     * @summary 批量删除店铺商品
     * @request POST:/thirdShopItem/batchDelete
     */
    batchDelete: (request: ThirdShopItemBatchDeleteRequest, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/thirdShopItem/batchDelete`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name BindSku
     * @summary 绑定店铺商品SKU
     * @request POST:/thirdShopItem/bindSku
     */
    bindSku: (request: ThirdShopItemBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/bindSku`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name DeleteItemSku
     * @summary 删除店铺商品sku
     * @request POST:/thirdShopItem/deleteItemSku
     */
    deleteItemSku: (request: ThirdShopItemDeleteRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/deleteItemSku`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name Export
     * @summary 导出三方SKU库存
     * @request POST:/thirdShopItem/export
     */
    export: (req: ThirdSkuStockQueryRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/thirdShopItem/export`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name GetLastTime
     * @summary 获取商品上次更新时间
     * @request GET:/thirdShopItem/getLastTime
     */
    getLastTime: (params: RequestParams = {}) =>
      this.request<BizResponseLastUpdateTimeResult, any>({
        path: `/thirdShopItem/getLastTime`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name GetShopItemDetail
     * @summary 取得店铺商品详情
     * @request GET:/thirdShopItem/getShopItemDetail
     */
    getShopItemDetail: (
      query: {
        /**
         * shopItemId
         * @format int64
         */
        shopItemId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseThirdShopItemResp, any>({
        path: `/thirdShopItem/getShopItemDetail`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name HasAvailableTransportationNums
     * @summary 是否有可用的在途库存
     * @request POST:/thirdShopItem/hasAvailableTransportationNums
     */
    hasAvailableTransportationNums: (reqDTO: ListOnTheWayStockPageRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopItem/hasAvailableTransportationNums`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name MappingSku
     * @summary 关联店铺商品SKU
     * @request POST:/thirdShopItem/mappingSku
     */
    mappingSku: (request: ThirdShopItemMappingRequest, params: RequestParams = {}) =>
      this.request<BizResponseThirdShopItemMappingResp, any>({
        path: `/thirdShopItem/mappingSku`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name PageOnTheWayStock
     * @summary 分页获取在途库存列表
     * @request POST:/thirdShopItem/pageOnTheWayStock
     */
    pageOnTheWayStock: (reqDTO: ListOnTheWayStockPageRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultOnTheWayStockQueryResoDTO, any>({
        path: `/thirdShopItem/pageOnTheWayStock`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name PageQuery
     * @summary 分页查询三方SKU库存
     * @request POST:/thirdShopItem/pageQuery
     */
    pageQuery: (req: ThirdSkuStockQueryRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdSkuStockStatics, any>({
        path: `/thirdShopItem/pageQuery`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name PageThirdShopItem
     * @summary 搜索第三方店铺商品
     * @request POST:/thirdShopItem/pageThirdShopItem
     */
    pageThirdShopItem: (request: ThirdShopItemQueryRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopItemResp, any>({
        path: `/thirdShopItem/pageThirdShopItem`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name PublishToShop
     * @summary 店铺商品一键上新-传输至店铺
     * @request POST:/thirdShopItem/publishToShop
     */
    publishToShop: (request: PublishItemToShopRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/publishToShop`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name PublishToShopCheck
     * @summary tiktok-传输至店铺check
     * @request POST:/thirdShopItem/publishToShopCheck
     */
    publishToShopCheck: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopItem/publishToShopCheck`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name QueryBindGoods
     * @summary 查询已绑定商品
     * @request POST:/thirdShopItem/queryBindGoods
     */
    queryBindGoods: (queryDTO: QueryBindGoodsReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseListQueryBindGoodsRespDTO, any>({
        path: `/thirdShopItem/queryBindGoods`,
        method: "POST",
        body: queryDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name QuerySkuList
     * @summary 店铺商品SKU列表
     * @request GET:/thirdShopItem/querySkuList
     */
    querySkuList: (
      query: {
        /**
         * shopItemId
         * @format int64
         */
        shopItemId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListThirdShopItemSkuResp, any>({
        path: `/thirdShopItem/querySkuList`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name QueryWhiteUserList
     * @summary 更新三方库存信息
     * @request POST:/thirdShopItem/queryWhiteUserList
     */
    queryWhiteUserList: (params: RequestParams = {}) =>
      this.request<BizResponseListLong, any>({
        path: `/thirdShopItem/queryWhiteUserList`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name RefreshItem
     * @summary 同步单个商品
     * @request GET:/thirdShopItem/refreshItem
     */
    refreshItem: (
      query: {
        /**
         * shopItemId
         * @format int64
         */
        shopItemId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/refreshItem`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name SyncItems
     * @summary 同步全部商品
     * @request GET:/thirdShopItem/syncItems
     */
    syncItems: (params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/syncItems`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UnbindSku
     * @summary 解绑店铺商品SKU
     * @request POST:/thirdShopItem/unbindSku
     */
    unbindSku: (request: ThirdShopItemUnbindRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/unbindSku`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UpdateItemAddition
     * @summary 编辑商品附加项
     * @request POST:/thirdShopItem/updateItemAddition
     */
    updateItemAddition: (request: UpdateItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/updateItemAddition`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UpdateItemRemark
     * @summary 修改商品番号
     * @request POST:/thirdShopItem/updateItemRemark
     */
    updateItemRemark: (request: UpdateItemRemarkRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopItem/updateItemRemark`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UpdateItemSkuAddition
     * @summary 编辑商品sku附加项
     * @request POST:/thirdShopItem/updateItemSkuAddition
     */
    updateItemSkuAddition: (request: UpdateItemSkuAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/updateItemSkuAddition`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UpdateItemSkuRemark
     * @summary 修改商品客样sku
     * @request POST:/thirdShopItem/updateItemSkuRemark
     */
    updateItemSkuRemark: (request: UpdateItemRemarkRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopItem/updateItemSkuRemark`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UpdateStaticItemSkuRemark
     * @summary 更新三方sku的客样sku
     * @request POST:/thirdShopItem/updateStaticItemSkuRemark
     */
    updateStaticItemSkuRemark: (req: UpdateSkuItemRemarkDTO, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopItem/updateStaticItemSkuRemark`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UpdateThirdSkuStock
     * @summary 更新三方库存信息
     * @request POST:/thirdShopItem/updateThirdSkuStock
     */
    updateThirdSkuStock: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopItem/updateThirdSkuStock`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdShopItemSku = {
    /**
     * No description
     *
     * @tags third-shop-item-sku-client-impl
     * @name GetByThirdSkuCode
     * @summary getByThirdSkuCode
     * @request GET:/thirdShopItemSku/getByThirdSkuCode
     */
    getByThirdSkuCode: (
      query: {
        /** thirdSkuCode */
        thirdSkuCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseThirdShopItemSkuResp, any>({
        path: `/thirdShopItemSku/getByThirdSkuCode`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-item-sku-client-impl
     * @name QueryMappingSkuList
     * @summary queryMappingSkuList
     * @request POST:/thirdShopItemSku/queryMappingSkuList
     */
    queryMappingSkuList: (req: ItemSkuMappingQueryReq, params: RequestParams = {}) =>
      this.request<BizResponseListString, any>({
        path: `/thirdShopItemSku/queryMappingSkuList`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-item-sku-client-impl
     * @name QueryMappingSpuList
     * @summary queryMappingSpuList
     * @request POST:/thirdShopItemSku/queryMappingSpuList
     */
    queryMappingSpuList: (req: ItemSkuMappingQueryReq, params: RequestParams = {}) =>
      this.request<BizResponseListString, any>({
        path: `/thirdShopItemSku/queryMappingSpuList`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-item-sku-client-impl
     * @name QueryProductSkuAllMappingList
     * @summary queryProductSkuAllMappingList
     * @request POST:/thirdShopItemSku/queryProductSkuAllMappingList
     */
    queryProductSkuAllMappingList: (req: ItemSkuMappingQueryReq, params: RequestParams = {}) =>
      this.request<BizResponseListItemSkuMappingResp, any>({
        path: `/thirdShopItemSku/queryProductSkuAllMappingList`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-item-sku-client-impl
     * @name QuerySkuMappingList
     * @summary querySkuMappingList
     * @request POST:/thirdShopItemSku/querySkuMappingList
     */
    querySkuMappingList: (req: ItemSkuMappingQueryReq, params: RequestParams = {}) =>
      this.request<BizResponseListItemSkuMappingResp, any>({
        path: `/thirdShopItemSku/querySkuMappingList`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdShopOrder = {
    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name BatchUpdateSyncLogisticsNo
     * @summary batchUpdateSynLogisticsNo
     * @request POST:/thirdShopOrder/batchUpdateSyncLogisticsNo
     */
    batchUpdateSyncLogisticsNo: (
      batchUpdateSyncLogisticsNoReq: BatchUpdateSyncLogisticsNoReq,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/batchUpdateSyncLogisticsNo`,
        method: "POST",
        body: batchUpdateSyncLogisticsNoReq,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders
     * @summary createShopOrder
     * @request GET:/thirdShopOrder/createPlatformOrders
     */
    createPlatformOrders: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder
     * @summary createShopOrder
     * @request HEAD:/thirdShopOrder/createPlatformOrders
     */
    headThirdShopOrder: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders2
     * @summary createShopOrder
     * @request POST:/thirdShopOrder/createPlatformOrders
     * @originalName createPlatformOrders
     * @duplicate
     */
    createPlatformOrders2: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders3
     * @summary createShopOrder
     * @request PUT:/thirdShopOrder/createPlatformOrders
     * @originalName createPlatformOrders
     * @duplicate
     */
    createPlatformOrders3: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders4
     * @summary createShopOrder
     * @request DELETE:/thirdShopOrder/createPlatformOrders
     * @originalName createPlatformOrders
     * @duplicate
     */
    createPlatformOrders4: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder
     * @summary createShopOrder
     * @request OPTIONS:/thirdShopOrder/createPlatformOrders
     */
    optionsThirdShopOrder: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders5
     * @summary createShopOrder
     * @request PATCH:/thirdShopOrder/createPlatformOrders
     * @originalName createPlatformOrders
     * @duplicate
     */
    createPlatformOrders5: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrder
     * @summary deleteShopOrder
     * @request POST:/thirdShopOrder/deleteShopOrder
     */
    deleteShopOrder: (req: DeleteShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrder`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem
     * @summary deleteShopOrderItem
     * @request GET:/thirdShopOrder/deleteShopOrderItem
     */
    deleteShopOrderItem: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder2
     * @summary deleteShopOrderItem
     * @request HEAD:/thirdShopOrder/deleteShopOrderItem
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder2: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem2
     * @summary deleteShopOrderItem
     * @request POST:/thirdShopOrder/deleteShopOrderItem
     * @originalName deleteShopOrderItem
     * @duplicate
     */
    deleteShopOrderItem2: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem3
     * @summary deleteShopOrderItem
     * @request PUT:/thirdShopOrder/deleteShopOrderItem
     * @originalName deleteShopOrderItem
     * @duplicate
     */
    deleteShopOrderItem3: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem4
     * @summary deleteShopOrderItem
     * @request DELETE:/thirdShopOrder/deleteShopOrderItem
     * @originalName deleteShopOrderItem
     * @duplicate
     */
    deleteShopOrderItem4: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder2
     * @summary deleteShopOrderItem
     * @request OPTIONS:/thirdShopOrder/deleteShopOrderItem
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder2: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem5
     * @summary deleteShopOrderItem
     * @request PATCH:/thirdShopOrder/deleteShopOrderItem
     * @originalName deleteShopOrderItem
     * @duplicate
     */
    deleteShopOrderItem5: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-client-impl
     * @name Delivery
     * @summary delivery
     * @request POST:/thirdShopOrder/delivery
     */
    delivery: (dto: OrderDeliveryReq, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/thirdShopOrder/delivery`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-client-impl
     * @name DeliveryCrossMall
     * @summary deliveryCrossMall
     * @request POST:/thirdShopOrder/deliveryCrossMall
     */
    deliveryCrossMall: (dto: OrderDeliveryReq, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/thirdShopOrder/deliveryCrossMall`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions
     * @summary editDeliveryAdditions
     * @request GET:/thirdShopOrder/editDeliveryAdditions
     */
    editDeliveryAdditions: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder3
     * @summary editDeliveryAdditions
     * @request HEAD:/thirdShopOrder/editDeliveryAdditions
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder3: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions2
     * @summary editDeliveryAdditions
     * @request POST:/thirdShopOrder/editDeliveryAdditions
     * @originalName editDeliveryAdditions
     * @duplicate
     */
    editDeliveryAdditions2: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions3
     * @summary editDeliveryAdditions
     * @request PUT:/thirdShopOrder/editDeliveryAdditions
     * @originalName editDeliveryAdditions
     * @duplicate
     */
    editDeliveryAdditions3: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions4
     * @summary editDeliveryAdditions
     * @request DELETE:/thirdShopOrder/editDeliveryAdditions
     * @originalName editDeliveryAdditions
     * @duplicate
     */
    editDeliveryAdditions4: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder3
     * @summary editDeliveryAdditions
     * @request OPTIONS:/thirdShopOrder/editDeliveryAdditions
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder3: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions5
     * @summary editDeliveryAdditions
     * @request PATCH:/thirdShopOrder/editDeliveryAdditions
     * @originalName editDeliveryAdditions
     * @duplicate
     */
    editDeliveryAdditions5: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig
     * @summary editIntShipConfig
     * @request GET:/thirdShopOrder/editIntShipConfig
     */
    editIntShipConfig: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder4
     * @summary editIntShipConfig
     * @request HEAD:/thirdShopOrder/editIntShipConfig
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder4: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig2
     * @summary editIntShipConfig
     * @request POST:/thirdShopOrder/editIntShipConfig
     * @originalName editIntShipConfig
     * @duplicate
     */
    editIntShipConfig2: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig3
     * @summary editIntShipConfig
     * @request PUT:/thirdShopOrder/editIntShipConfig
     * @originalName editIntShipConfig
     * @duplicate
     */
    editIntShipConfig3: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig4
     * @summary editIntShipConfig
     * @request DELETE:/thirdShopOrder/editIntShipConfig
     * @originalName editIntShipConfig
     * @duplicate
     */
    editIntShipConfig4: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder4
     * @summary editIntShipConfig
     * @request OPTIONS:/thirdShopOrder/editIntShipConfig
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder4: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig5
     * @summary editIntShipConfig
     * @request PATCH:/thirdShopOrder/editIntShipConfig
     * @originalName editIntShipConfig
     * @duplicate
     */
    editIntShipConfig5: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name FixOrderReceiver
     * @summary fixOrderReceiver
     * @request POST:/thirdShopOrder/fixOrderReceiver
     */
    fixOrderReceiver: (params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/thirdShopOrder/fixOrderReceiver`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetMissingItemOrderFlag
     * @summary 获取未关联下单店铺白名单标识
     * @request GET:/thirdShopOrder/getMissingItemOrderFlag
     */
    getMissingItemOrderFlag: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/getMissingItemOrderFlag`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetOpenOverSeaSwitch
     * @summary 获取开启海外仓下单开关
     * @request GET:/thirdShopOrder/getOpenOverSeaSwitch
     */
    getOpenOverSeaSwitch: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/getOpenOverSeaSwitch`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList
     * @summary getShopOrderItemList
     * @request GET:/thirdShopOrder/getShopOrderItemList
     */
    getShopOrderItemList: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder5
     * @summary getShopOrderItemList
     * @request HEAD:/thirdShopOrder/getShopOrderItemList
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder5: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "HEAD",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList2
     * @summary getShopOrderItemList
     * @request POST:/thirdShopOrder/getShopOrderItemList
     * @originalName getShopOrderItemList
     * @duplicate
     */
    getShopOrderItemList2: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList3
     * @summary getShopOrderItemList
     * @request PUT:/thirdShopOrder/getShopOrderItemList
     * @originalName getShopOrderItemList
     * @duplicate
     */
    getShopOrderItemList3: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "PUT",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList4
     * @summary getShopOrderItemList
     * @request DELETE:/thirdShopOrder/getShopOrderItemList
     * @originalName getShopOrderItemList
     * @duplicate
     */
    getShopOrderItemList4: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder5
     * @summary getShopOrderItemList
     * @request OPTIONS:/thirdShopOrder/getShopOrderItemList
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder5: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "OPTIONS",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList5
     * @summary getShopOrderItemList
     * @request PATCH:/thirdShopOrder/getShopOrderItemList
     * @originalName getShopOrderItemList
     * @duplicate
     */
    getShopOrderItemList5: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "PATCH",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetWaitReplenishShopOrderItemList
     * @summary getWaitReplenishShopOrderItemList
     * @request GET:/thirdShopOrder/getWaitReplenishShopOrderItemList
     */
    getWaitReplenishShopOrderItemList: (
      query?: {
        /** purchaseCountry */
        purchaseCountry?: string;
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getWaitReplenishShopOrderItemList`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder6
     * @summary getWaitReplenishShopOrderItemList
     * @request HEAD:/thirdShopOrder/getWaitReplenishShopOrderItemList
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder6: (
      query?: {
        /** purchaseCountry */
        purchaseCountry?: string;
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getWaitReplenishShopOrderItemList`,
        method: "HEAD",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetWaitReplenishShopOrderItemList2
     * @summary getWaitReplenishShopOrderItemList
     * @request POST:/thirdShopOrder/getWaitReplenishShopOrderItemList
     * @originalName getWaitReplenishShopOrderItemList
     * @duplicate
     */
    getWaitReplenishShopOrderItemList2: (
      query?: {
        /** purchaseCountry */
        purchaseCountry?: string;
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getWaitReplenishShopOrderItemList`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetWaitReplenishShopOrderItemList3
     * @summary getWaitReplenishShopOrderItemList
     * @request PUT:/thirdShopOrder/getWaitReplenishShopOrderItemList
     * @originalName getWaitReplenishShopOrderItemList
     * @duplicate
     */
    getWaitReplenishShopOrderItemList3: (
      query?: {
        /** purchaseCountry */
        purchaseCountry?: string;
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getWaitReplenishShopOrderItemList`,
        method: "PUT",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetWaitReplenishShopOrderItemList4
     * @summary getWaitReplenishShopOrderItemList
     * @request DELETE:/thirdShopOrder/getWaitReplenishShopOrderItemList
     * @originalName getWaitReplenishShopOrderItemList
     * @duplicate
     */
    getWaitReplenishShopOrderItemList4: (
      query?: {
        /** purchaseCountry */
        purchaseCountry?: string;
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getWaitReplenishShopOrderItemList`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder6
     * @summary getWaitReplenishShopOrderItemList
     * @request OPTIONS:/thirdShopOrder/getWaitReplenishShopOrderItemList
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder6: (
      query?: {
        /** purchaseCountry */
        purchaseCountry?: string;
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getWaitReplenishShopOrderItemList`,
        method: "OPTIONS",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetWaitReplenishShopOrderItemList5
     * @summary getWaitReplenishShopOrderItemList
     * @request PATCH:/thirdShopOrder/getWaitReplenishShopOrderItemList
     * @originalName getWaitReplenishShopOrderItemList
     * @duplicate
     */
    getWaitReplenishShopOrderItemList5: (
      query?: {
        /** purchaseCountry */
        purchaseCountry?: string;
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getWaitReplenishShopOrderItemList`,
        method: "PATCH",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name IsT2SShop
     * @summary 获取开启海外仓下单开关
     * @request GET:/thirdShopOrder/isT2SShop
     */
    isT2SShop: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/isT2SShop`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder
     * @summary manualSyncOrder
     * @request GET:/thirdShopOrder/manualSyncOrder
     */
    manualSyncOrder: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder7
     * @summary manualSyncOrder
     * @request HEAD:/thirdShopOrder/manualSyncOrder
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder7: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder2
     * @summary manualSyncOrder
     * @request POST:/thirdShopOrder/manualSyncOrder
     * @originalName manualSyncOrder
     * @duplicate
     */
    manualSyncOrder2: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder3
     * @summary manualSyncOrder
     * @request PUT:/thirdShopOrder/manualSyncOrder
     * @originalName manualSyncOrder
     * @duplicate
     */
    manualSyncOrder3: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder4
     * @summary manualSyncOrder
     * @request DELETE:/thirdShopOrder/manualSyncOrder
     * @originalName manualSyncOrder
     * @duplicate
     */
    manualSyncOrder4: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder7
     * @summary manualSyncOrder
     * @request OPTIONS:/thirdShopOrder/manualSyncOrder
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder7: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder5
     * @summary manualSyncOrder
     * @request PATCH:/thirdShopOrder/manualSyncOrder
     * @originalName manualSyncOrder
     * @duplicate
     */
    manualSyncOrder5: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryCount
     * @summary queryCount
     * @request GET:/thirdShopOrder/queryCount
     */
    queryCount: (params: RequestParams = {}) =>
      this.request<BizResponseQueryOrderCountRespDTO, any>({
        path: `/thirdShopOrder/queryCount`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-client-impl
     * @name QueryOrderTime
     * @summary queryOrderTime
     * @request GET:/thirdShopOrder/queryOrderTime
     */
    queryOrderTime: (
      query: {
        /** shopOrderIds */
        shopOrderIds: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListThirdShopOrderTimeResp, any>({
        path: `/thirdShopOrder/queryOrderTime`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder
     * @summary queryShopOrder
     * @request GET:/thirdShopOrder/queryShopOrder
     */
    queryShopOrder: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder8
     * @summary queryShopOrder
     * @request HEAD:/thirdShopOrder/queryShopOrder
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder8: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder2
     * @summary queryShopOrder
     * @request POST:/thirdShopOrder/queryShopOrder
     * @originalName queryShopOrder
     * @duplicate
     */
    queryShopOrder2: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder3
     * @summary queryShopOrder
     * @request PUT:/thirdShopOrder/queryShopOrder
     * @originalName queryShopOrder
     * @duplicate
     */
    queryShopOrder3: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder4
     * @summary queryShopOrder
     * @request DELETE:/thirdShopOrder/queryShopOrder
     * @originalName queryShopOrder
     * @duplicate
     */
    queryShopOrder4: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder8
     * @summary queryShopOrder
     * @request OPTIONS:/thirdShopOrder/queryShopOrder
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder8: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder5
     * @summary queryShopOrder
     * @request PATCH:/thirdShopOrder/queryShopOrder
     * @originalName queryShopOrder
     * @duplicate
     */
    queryShopOrder5: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryThirdShopItemSku
     * @summary queryThirdShopItemSku
     * @request GET:/thirdShopOrder/queryThirdShopItemSku
     */
    queryThirdShopItemSku: (
      query?: {
        /** 子订单系统单号 */
        orderCode?: string;
        /** 直行便订单编号 */
        platformOrderNo?: string;
        /** 平台sku */
        productSku?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseThirdShopOrderSkuDTO, any>({
        path: `/thirdShopOrder/queryThirdShopItemSku`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryWaitReplenishShopOrder
     * @summary queryWaitReplenishShopOrder
     * @request GET:/thirdShopOrder/queryWaitReplenishShopOrder
     */
    queryWaitReplenishShopOrder: (req: QueryWaitReplenishOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryWaitReplenishShopOrder`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder9
     * @summary queryWaitReplenishShopOrder
     * @request HEAD:/thirdShopOrder/queryWaitReplenishShopOrder
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder9: (req: QueryWaitReplenishOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryWaitReplenishShopOrder`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryWaitReplenishShopOrder2
     * @summary queryWaitReplenishShopOrder
     * @request POST:/thirdShopOrder/queryWaitReplenishShopOrder
     * @originalName queryWaitReplenishShopOrder
     * @duplicate
     */
    queryWaitReplenishShopOrder2: (req: QueryWaitReplenishOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryWaitReplenishShopOrder`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryWaitReplenishShopOrder3
     * @summary queryWaitReplenishShopOrder
     * @request PUT:/thirdShopOrder/queryWaitReplenishShopOrder
     * @originalName queryWaitReplenishShopOrder
     * @duplicate
     */
    queryWaitReplenishShopOrder3: (req: QueryWaitReplenishOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryWaitReplenishShopOrder`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryWaitReplenishShopOrder4
     * @summary queryWaitReplenishShopOrder
     * @request DELETE:/thirdShopOrder/queryWaitReplenishShopOrder
     * @originalName queryWaitReplenishShopOrder
     * @duplicate
     */
    queryWaitReplenishShopOrder4: (req: QueryWaitReplenishOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryWaitReplenishShopOrder`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder9
     * @summary queryWaitReplenishShopOrder
     * @request OPTIONS:/thirdShopOrder/queryWaitReplenishShopOrder
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder9: (req: QueryWaitReplenishOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryWaitReplenishShopOrder`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryWaitReplenishShopOrder5
     * @summary queryWaitReplenishShopOrder
     * @request PATCH:/thirdShopOrder/queryWaitReplenishShopOrder
     * @originalName queryWaitReplenishShopOrder
     * @duplicate
     */
    queryWaitReplenishShopOrder5: (req: QueryWaitReplenishOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryWaitReplenishShopOrder`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name Test
     * @summary test
     * @request GET:/thirdShopOrder/test
     */
    test: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/test`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder10
     * @summary test
     * @request HEAD:/thirdShopOrder/test
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder10: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/test`,
        method: "HEAD",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name Test2
     * @summary test
     * @request POST:/thirdShopOrder/test
     * @originalName test
     * @duplicate
     */
    test2: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/test`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name Test3
     * @summary test
     * @request PUT:/thirdShopOrder/test
     * @originalName test
     * @duplicate
     */
    test3: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/test`,
        method: "PUT",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name Test4
     * @summary test
     * @request DELETE:/thirdShopOrder/test
     * @originalName test
     * @duplicate
     */
    test4: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/test`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder10
     * @summary test
     * @request OPTIONS:/thirdShopOrder/test
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder10: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/test`,
        method: "OPTIONS",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name Test5
     * @summary test
     * @request PATCH:/thirdShopOrder/test
     * @originalName test
     * @duplicate
     */
    test5: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/test`,
        method: "PATCH",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition
     * @summary updateOrderItemAddition
     * @request GET:/thirdShopOrder/updateOrderItemAddition
     */
    updateOrderItemAddition: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder11
     * @summary updateOrderItemAddition
     * @request HEAD:/thirdShopOrder/updateOrderItemAddition
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder11: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition2
     * @summary updateOrderItemAddition
     * @request POST:/thirdShopOrder/updateOrderItemAddition
     * @originalName updateOrderItemAddition
     * @duplicate
     */
    updateOrderItemAddition2: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition3
     * @summary updateOrderItemAddition
     * @request PUT:/thirdShopOrder/updateOrderItemAddition
     * @originalName updateOrderItemAddition
     * @duplicate
     */
    updateOrderItemAddition3: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition4
     * @summary updateOrderItemAddition
     * @request DELETE:/thirdShopOrder/updateOrderItemAddition
     * @originalName updateOrderItemAddition
     * @duplicate
     */
    updateOrderItemAddition4: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder11
     * @summary updateOrderItemAddition
     * @request OPTIONS:/thirdShopOrder/updateOrderItemAddition
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder11: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition5
     * @summary updateOrderItemAddition
     * @request PATCH:/thirdShopOrder/updateOrderItemAddition
     * @originalName updateOrderItemAddition
     * @duplicate
     */
    updateOrderItemAddition5: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateShopOrderAddress
     * @summary updateShopOrderAddress
     * @request POST:/thirdShopOrder/updateShopOrderAddress
     */
    updateShopOrderAddress: (req: UpdateShopOrderReceiverRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateShopOrderAddress`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo
     * @summary updateSynLogisticsNo
     * @request GET:/thirdShopOrder/updateSynLogisticsNo
     */
    updateSynLogisticsNo: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder12
     * @summary updateSynLogisticsNo
     * @request HEAD:/thirdShopOrder/updateSynLogisticsNo
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder12: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "HEAD",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo2
     * @summary updateSynLogisticsNo
     * @request POST:/thirdShopOrder/updateSynLogisticsNo
     * @originalName updateSynLogisticsNo
     * @duplicate
     */
    updateSynLogisticsNo2: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo3
     * @summary updateSynLogisticsNo
     * @request PUT:/thirdShopOrder/updateSynLogisticsNo
     * @originalName updateSynLogisticsNo
     * @duplicate
     */
    updateSynLogisticsNo3: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "PUT",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo4
     * @summary updateSynLogisticsNo
     * @request DELETE:/thirdShopOrder/updateSynLogisticsNo
     * @originalName updateSynLogisticsNo
     * @duplicate
     */
    updateSynLogisticsNo4: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder12
     * @summary updateSynLogisticsNo
     * @request OPTIONS:/thirdShopOrder/updateSynLogisticsNo
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder12: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "OPTIONS",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo5
     * @summary updateSynLogisticsNo
     * @request PATCH:/thirdShopOrder/updateSynLogisticsNo
     * @originalName updateSynLogisticsNo
     * @duplicate
     */
    updateSynLogisticsNo5: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "PATCH",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  tiktok = {
    /**
     * No description
     *
     * @tags tiktok-shop-app-controller
     * @name Auth
     * @summary authTiktok
     * @request POST:/tiktok/auth
     */
    auth: (request: TiktokAuthRequest, params: RequestParams = {}) =>
      this.request<BizResponseLong, any>({
        path: `/tiktok/auth`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags tiktok-shop-app-controller
     * @name UpdateGoogleStatus
     * @summary updateGoogleStatus
     * @request POST:/tiktok/update/google/status
     */
    updateGoogleStatus: (reqDTO: UpdateGoogleStatusReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/tiktok/update/google/status`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags tiktok-shop-app-controller
     * @name Webhook
     * @summary webhook
     * @request POST:/tiktok/webhook
     */
    webhook: (webhookRequest: TiktokShopWebhookRequestDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/tiktok/webhook`,
        method: "POST",
        body: webhookRequest,
        type: ContentType.Json,
        ...params,
      }),
  };
  tts = {
    /**
     * No description
     *
     * @tags tts-controller
     * @name Categories
     * @summary categories
     * @request GET:/tts/categories
     */
    categories: (params: RequestParams = {}) =>
      this.request<BizResponseListTTSCategoryResp, any>({
        path: `/tts/categories`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tts-controller
     * @name CreatProductCheck
     * @summary creatProductCheck
     * @request GET:/tts/creatProductCheck
     */
    creatProductCheck: (
      query: {
        /** productCode */
        productCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/tts/creatProductCheck`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags tts-controller
     * @name SetSkuStock
     * @summary setSkuStock
     * @request GET:/tts/setSkuStock
     */
    setSkuStock: (
      query: {
        /**
         * stockNum
         * @format int32
         */
        stockNum: number;
        /** thirdSkuCode */
        thirdSkuCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/tts/setSkuStock`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags tts-controller
     * @name Ttttt
     * @summary ttttt
     * @request GET:/tts/ttttt
     */
    ttttt: (params: RequestParams = {}) =>
      this.request<BizResponseListTTSCategoryResp, any>({
        path: `/tts/ttttt`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tts-controller
     * @name UploadImage
     * @summary uploadImage
     * @request POST:/tts/uploadImage
     */
    uploadImage: (
      query: {
        /** useCase */
        useCase: string;
      },
      data: {
        /** file */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseString, any>({
        path: `/tts/uploadImage`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  userFees = {
    /**
     * No description
     *
     * @tags userFees
     * @name FeeDetailDeliveryCostAnalysis
     * @summary Query delivery settlement fee details
     * @request POST:/userFees/feeDetail/deliveryCostAnalysis
     */
    feeDetailDeliveryCostAnalysis: (
      deliverySkuFeeDetailReqDTO: DeliverySkuFeeDetailReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<DeliverySkuFeeDetailRespDTO, any>({
        path: `/userFees/feeDetail/deliveryCostAnalysis`,
        method: "POST",
        body: deliverySkuFeeDetailReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags userFees
     * @name FeeDetailFundFlow
     * @summary Query flow settlement fee details
     * @request POST:/userFees/feeDetail/fundFlow
     */
    feeDetailFundFlow: (shopFundFlowDetailReqDTO: ShopFundFlowDetailReqDTO, params: RequestParams = {}) =>
      this.request<ShopFundFlowDetailRespDTO, any>({
        path: `/userFees/feeDetail/fundFlow`,
        method: "POST",
        body: shopFundFlowDetailReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 根据店铺ID获取资金使用明细
     *
     * @tags userFees
     * @name FeeDetailFundUtilizationDetails
     * @summary 获取店铺资金使用明细
     * @request POST:/userFees/feeDetail/fundUtilizationDetails
     */
    feeDetailFundUtilizationDetails: (request: FundUtilizationDetailsRequestDTO, params: RequestParams = {}) =>
      this.request<BizResponseFundUtilizationDetailsData, any>({
        path: `/userFees/feeDetail/fundUtilizationDetails`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags userFees
     * @name FeeDetailOrderSku
     * @summary Query order SKU settlement fee details
     * @request POST:/userFees/feeDetail/orderSku
     */
    feeDetailOrderSku: (reqDTO: OrderSkuFeeDetailReqDTO, params: RequestParams = {}) =>
      this.request<OrderSkuFeeDetailRespDTO, any>({
        path: `/userFees/feeDetail/orderSku`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 根据订单编码获取订单商品行费用数量明细
     *
     * @tags userFees
     * @name FeeDetailOrderSkuFee
     * @summary 获取订单商品行费用数量明细
     * @request POST:/userFees/feeDetail/orderSkuFee
     */
    feeDetailOrderSkuFee: (requestDTO: OrderSkuFeeNumberDetailsRequestDTO, params: RequestParams = {}) =>
      this.request<BizResponseOrderSkuFeeNumberDetailsRespDTO, any>({
        path: `/userFees/feeDetail/orderSkuFee`,
        method: "POST",
        body: requestDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 根据订单编码获取直发订单商品行囤货单费用明细
     *
     * @tags userFees
     * @name FeeDetailOrderSkuStockFee
     * @summary 获取直发订单商品行囤货单费用明细
     * @request POST:/userFees/feeDetail/orderSkuStockFee
     */
    feeDetailOrderSkuStockFee: (requestDTO: OrderSkuStockFeeDetailsRequestDTO, params: RequestParams = {}) =>
      this.request<BizResponseOrderSkuStockFeeDetailsRespDTO, any>({
        path: `/userFees/feeDetail/orderSkuStockFee`,
        method: "POST",
        body: requestDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags userFees
     * @name FeeDetailProductStock
     * @summary Query product stock details
     * @request POST:/userFees/feeDetail/productStock
     */
    feeDetailProductStock: (shopStockDetailReqDTO: ShopStockDetailReqDTO, params: RequestParams = {}) =>
      this.request<ShopStockDetailRespDTO, any>({
        path: `/userFees/feeDetail/productStock`,
        method: "POST",
        body: shopStockDetailReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  webhook = {
    /**
     * No description
     *
     * @tags cafe-24-webhook-controller
     * @name Cafe24DelApp
     * @summary delApp
     * @request POST:/webhook/cafe24/delApp
     */
    cafe24DelApp: (delAppWebhookDTO: DelAppWebhookDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/webhook/cafe24/delApp`,
        method: "POST",
        body: delAppWebhookDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺信息，客户信息
     * @name CustomerList
     * @summary customerData
     * @request POST:/webhook/customer/list
     */
    customerList: (params: RequestParams = {}) =>
      this.request<ThirdShopAuth[], any>({
        path: `/webhook/customer/list`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺信息，客户信息
     * @name DeleteCustomer
     * @summary deleteCustomer
     * @request POST:/webhook/delete/customer
     */
    deleteCustomer: (params: RequestParams = {}) =>
      this.request<ResponseEntity, any>({
        path: `/webhook/delete/customer`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺信息，客户信息
     * @name DeleteShop
     * @summary deleteShop
     * @request POST:/webhook/delete/shop
     */
    deleteShop: (params: RequestParams = {}) =>
      this.request<ResponseEntity, any>({
        path: `/webhook/delete/shop`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
}
